import {CurrencyPipe, DatePipe} from '@angular/common';
import {KeyLocalStorage, ProveedorLogin, VinculosExternos} from '../core/models/enum/emun-enumeracion';
import {IgcContentPane, IgcDockManagerPane, IgcDockManagerPaneType, IgcSplitPane, IgcTabGroupPane} from '@infragistics/igniteui-dockmanager';
import {DmSecundarioComponent} from '../componentes/00-contenedores/docker-manager/dmseundario/dm-secundario.component';
import {
  ClsCatalogoPresupuestos,
  ClsImportePorTipo,
  ClsPartidasConceptosExpIns,
  ClsPresupuestos,
} from '../core/models/cls-presupuestos';
import {AppPresupuestosService} from '../core/services/app-presupuestos.service';
import JSZip from 'jszip';
import {v4 as uuidv4} from 'uuid';
import {
  IgxExcelExporterOptions,
  IgxExcelExporterService,
  IgxPdfExporterOptions,
  IgxPdfExporterService
} from '@infragistics/igniteui-angular/grids/core';
import {IgxGridComponent} from '@infragistics/igniteui-angular/grids/grid';
import {IgxTreeGridComponent} from '@infragistics/igniteui-angular/grids/tree-grid';
import {ITreeGridRecord} from '@infragistics/igniteui-angular/core';
import {
  Workbook,
  WorkbookFormat,
  Worksheet,
  WorksheetCell,
  WorksheetImage,
  WorksheetShape,
  WorksheetShapeCollection
} from 'igniteui-angular-excel';
import {AppInfoService} from '../core/services/app-info.service';
import {ClsAccessToken} from '../core/models/cls-access-token';
import {
  ClsAdjuntos,
  ClsArchivoBase64,
  ClsDataEnvioCorreo,
  ClsEnviarCorreo,
  ClsParametrosEnviaCorreo
} from '../core/models/cls-envio-correo';
import {ClsNotificaciones, ClsRespuestaPresupuestos} from '../core/models/peticiones/cls-pr-presupuestos';
import {ClsObjExplosionDeInsumos} from '../clases-pu/01-presupuesto/menu-presupuesto/cls-obj-explosion-de-insumos';
import {ClsObjPresupuestoPartidas} from '../clases-pu/01-presupuesto/presupuesto/cls-obj-presupuesto-partidas';
import {ClsObjPresupuesto} from '../clases-pu/01-presupuesto/presupuesto/cls-obj-presupuesto';
import {IPptoCompleto} from '../core/models/interfaces/generico-interface';
import {saveAs} from 'file-saver';
import {
  ClsCalculoCatalogo,
  ClsCalculoDetalleExpXConcepto,
  ClsCalculoOrderNivel,
  ClsCatalogoCostosCalculo,
  ClsCatalogoCostosOPCalculo,
  ClsCatalogoMOCalculo
} from '../core/models/cls-calculo';
import {ClsObjGenerico} from '../clases-pu/util/cls-obj-generico';
import {ClsEncabezadoReporte} from '../core/models/cls-reportes';
import {ClsObjCatalogoPresupuestosGenerales} from '../clases-pu/cls-obj-catalogo-presupuestos-generales';
import {EnumLibros, EnumParaPpto} from '../core/models/enum/enum-parametros';
import {ClsArbolPartida, ClsArbolPartidaNiveles, ClsConceptosPartida} from '../core/models/cls-partida';
import {ClsCatalogosExpIns} from '../core/models/cls-catalogo-general';
import {ClsDetalleMatrizInsumos, ClsMatriz} from '../core/models/cls-matriz';
import {ClsArchivosEntrada, ClsContenidoBucketStorage, ClsListaArchivos} from '../core/models/cls-storage';
import {ClsDatosBucketSube, ClsRespuestaDescargaArchivosStorage} from '../core/models/peticiones/cls-pr-storage';
import {ClsObjCalculo} from '../clases-pu/01-presupuesto/calculo/cls-obj-calculo';
import {ClsCostoHorarios} from '../core/models/cls-costo-horarios';
import {ClsParametro} from '../core/models/cls-parametros';
import {EnumTipoParametro} from '../core/models/enum/enum-tipo-parametro';
import {ClsObjParametrosPorPpto} from '../clases-pu/util/cls-obj-parametros-por-ppto';
import {EnumMenuOpIDPpto, EnumMenuOpIDPrincipal} from '../core/models/enum/enum-menus-opciones';
import {EnumMIMETypes} from '../core/models/enum/enum-mas-opciones';
import {ClsObjCostoHorario} from '../clases-pu/01-presupuesto/presupuesto/cls-obj-costo-horario';
import {ClsObjMatrices} from '../clases-pu/01-presupuesto/matrices/cls-obj-matrices';
import JSONbigString from 'json-bigint';
import {EnumSocket} from "../core/models/enum/enum-socket";
import {
  ClsOpcionesPDF,
  PersonalizarPdfComponent
} from '../componentes/util/ventanas/personalizar-pdf/personalizar-pdf.component';
import {VtnGenericaComponent} from '../componentes/util/ventanas/vtn-generica/vtn-generica.component';
import {CrearComponenteDinamicoService} from '../core/services/crear-componente-dinamico.service';
import {TipoMensajesService} from '../core/services/tipo-mensajes.service';
import {IProgSumExplosionDetalle, MergeResult} from "../core/models/peticiones/cls-pr-calculo-prog";

export type NeoNotificationTone = 'success' | 'warning' | 'danger';
export type NeoExternalColorKey =
  | 'brand-primary'
  | 'brand-primary-strong'
  | 'brand-danger-strong'
  | 'avatar-danger'
  | 'notification-add'
  | 'notification-update'
  | 'notification-delete'
  | 'share-delete'
  | 'excel-header-fill'
  | 'excel-header-text';

export class ClsUtil {
  static TABNEO = '&0t';
  static TAB = '\t';
  static ENTERNEO = '&0n';
  static ENTER = '\n';
  protected static datePipe: DatePipe;
  protected static monedaPipe: CurrencyPipe;
  protected static offset: string;
  protected static b64pad = '=';
  protected static b64u = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'; // base64url dictionary
  protected static contador: number = 0;
  protected static ultimoMilisegundo: number = 0;
  private static readonly neoExternalPalette: Record<NeoExternalColorKey, string> = {
    'brand-primary': '#3389EB',
    'brand-primary-strong': '#1260BA',
    'brand-danger-strong': '#B91C1C',
    'avatar-danger': '#EF4444',
    'notification-add': '#047857',
    'notification-update': '#A16207',
    'notification-delete': '#B91C1C',
    'share-delete': '#B91C1C',
    'excel-header-fill': '#EAB308',
    'excel-header-text': '#0A0A0A'
  };

  public static esNulo(valor: any): boolean {
    if (valor === undefined || valor === null) {
      return true;
    } else {
      return valor === '';
    }
  }

  /**
   * se pone en NULL para que en el grid no se vea fecha default
   * @param valor fecha a validar
   */
  public static convertirAFechaReal(valor: any): any {
    if (this.esNulo(valor)) {
      return valor;
    } else {
      if (valor === '' || valor === '0000-00-00' || valor === '0001-01-01T00:00:00Z') {
        return valor = null;
      } else {
        const endsWithZ = valor.toString().endsWith('Z');
        // los formatos que tiene 20 caracteres, indica que se guardo solo fecha
        // y si no se hace este proceso de validacion al exportar a excel algun grid que tiene fecha lo manda con otra fecha
        if (valor.toString().length === 20 && endsWithZ) {
          valor = valor.toString().replace('Z', '');
        }
        return new Date(valor.toString());
      }
    }
  }

  public static cadenaX(valor: any): string {
    if (this.esNulo(valor)) {
      return '';
    }
    return valor.toString();
  }

  public static numberX(valor: any, sinFormato = false): number {
    if (this.esNulo(valor)) {
      return 0;
    }
    if (sinFormato) {
      valor = valor.toString().replace(/[$,]+/g, '');
    }
    return Number(valor);
  }

  public static bigintX(valor: any): bigint {
    let resp = BigInt('0');
    if (this.esNulo(valor)) {
      return resp;
    }
    try {
      resp = BigInt(valor.toString());
    } catch (e) {
    }
    return resp;
  }

  public static toArrayBigIntX(valor: string): any {
    if (valor === '[]' || this.esNulo(valor)) {
      return [];
    }
    const cut = valor.slice(1, valor.length - 1);
    const arr = cut.split(',');
    return arr.map(x => BigInt(x.toString()));
  }

  public static obtenerLocalGrid(): string {
    const lenguaje: string = this.obtenerLenguaje();
    return lenguaje === 'es' ? 'es-MX' : 'en-US';
  }

  public static obtenerLenguaje(): string {
    return localStorage.getItem(KeyLocalStorage.Lenguaje) || 'es'
  }

  public static getExternalColor(key: NeoExternalColorKey): string {
    return this.neoExternalPalette[key];
  }

  public static resolveThemeColor(documento: Document, token: string, fallback = ''): string {
    if (this.esNulo(documento) || this.esNulo(token)) {
      return fallback;
    }
    const value = getComputedStyle(documento.documentElement).getPropertyValue(token).trim();
    return value || fallback;
  }

  public static getNotificationTone(tipo: EnumSocket): NeoNotificationTone {
    switch (tipo) {
      case EnumSocket.AgregarExpIns:
      case EnumSocket.AgregarPartida:
        return 'success';
      case EnumSocket.ModificarExpIns:
      case EnumSocket.ModificarPartida:
      case EnumSocket.ModificarConcepto:
      case EnumSocket.ModificarMatriz:
      case EnumSocket.ModificarCH:
      case EnumSocket.RenombrarPartida:
      case EnumSocket.MoverPartida:
      case EnumSocket.PendienteAnalizar:
        return 'warning';
      case EnumSocket.BorrarExpIns:
      case EnumSocket.BorrarPartida:
        return 'danger';
      default:
        return 'warning';
    }
  }

  public static getNotificationColor(tipo: EnumSocket): string {
    return this.getNotificationColorByTone(this.getNotificationTone(tipo));
  }

  public static getNotificationColorByTone(tone: NeoNotificationTone): string {
    switch (tone) {
      case 'success':
        return this.getExternalColor('notification-add');
      case 'warning':
        return this.getExternalColor('notification-update');
      case 'danger':
        return this.getExternalColor('notification-delete');
    }
  }

  public static getShareActionColor(tipo: string): string {
    switch (tipo) {
      case 'add':
        return this.getExternalColor('notification-add');
      case 'update':
        return this.getExternalColor('notification-update');
      case 'delete':
        return this.getExternalColor('share-delete');
      default:
        return this.getExternalColor('notification-update');
    }
  }

  public static obtenerAccessToken(infApp: AppInfoService): ClsAccessToken {
    const zonaHoraria = new Date().getTimezoneOffset();
    this.offset = (-zonaHoraria / 60).toString();

    // obtener sesion si es que tiene el usuario que esta logueandose
    const sesiones: any[] = ClsUtil.parseJSONBig(localStorage.getItem(KeyLocalStorage.Sesion)) || [];

    const existingSesionIndex = sesiones.findIndex(sesion => sesion.email === infApp.usuarioLogeado.email);

    if (existingSesionIndex !== -1) {
      infApp.usuarioLogeado.sesion = sesiones[existingSesionIndex].sesion;
    }

    infApp.usuarioLogeado.modoLogin = (infApp.provLogin === ProveedorLogin.Microsoft) ? 'Microsoft' : 'Google';
    return {
      AccessToken: infApp.usuarioLogeado.accessToken,
      RefreshToken: infApp.usuarioLogeado.refreshToken,
      ZonaHoraria: this.offset,
      CodigoSistema: 'PU',
      IdSesion: infApp.usuarioLogeado.sesion,
      ModoLogin: infApp.usuarioLogeado.modoLogin,
      Idioma: this.esNulo(infApp.translate) ? localStorage.getItem(KeyLocalStorage.Lenguaje).toString() : infApp.translate.getCurrentLang().toLowerCase(),
      EsNube: true,
      Version: 'punube+'
    };
  }

  public static parseJSONBig(value: any): any {
    return JSONbigString({useNativeBigInt: true}).parse(value);
  }

  public static stringifyJSONBig(value: any): any {
    return JSONbigString({useNativeBigInt: true}).stringify(value);
  }

  public static parseJSON(value: any): any {
    return JSON.parse(value, (key, value1) => {
      if (typeof value1 === 'number') {
        if (value1.toString().length > 16) {
          value1 = BigInt(value1.toString());
        }
      }

      return value1;
    });
  }

  // public static stringifyJSON(value: any): any {
  //   return JSON.stringify(value);
  // }

  public static formatoFechaManualPipe(valor: any, formato: string) {
    if (this.esNulo(this.datePipe)) {
      this.datePipe = new DatePipe(this.obtenerLocalGrid());
    }
    return this.datePipe.transform(valor, formato);
  }

  public static formatoMonedaPipe(value: any, digitsInfo = '1.2-2') {
    if (this.monedaPipe === undefined) {
      this.monedaPipe = new CurrencyPipe(this.obtenerLocalGrid());
    }
    return this.monedaPipe.transform(value, '$ ', 'symbol-narrow', digitsInfo, this.obtenerLocalGrid());
  }

  public static formatoMonedaPipeSinSimbolo$ConDecimal(value: any, digitsInfo = '1.2-2') {
    if (this.monedaPipe === undefined) {
      this.monedaPipe = new CurrencyPipe(this.obtenerLocalGrid());
    }
    return this.monedaPipe.transform(value, '', '', digitsInfo, this.obtenerLocalGrid());
  }

  // base64 encoded ascii to ucs-2 string
  // public static decodificar(str) {
  //   return decodeURIComponent(escape(window.atob(str)));
  // }
  //
  // public static codificar(str) {
  //   return window.btoa(unescape(encodeURIComponent(str)));
  // }

  public static abrirRedesSociales(vinculos: VinculosExternos) {
    switch (vinculos) {
      case VinculosExternos.Home:
        this.vistaPrevia('https://neodata.mx/');
        break;
      case VinculosExternos.Youtube:
        this.vistaPrevia('https://www.youtube.com/user/NeodataTV');
        break;
      case VinculosExternos.Facebook:
        this.vistaPrevia('https://www.facebook.com/neodataMatriz/');
        break;
      case VinculosExternos.Soporte:
        this.vistaPrevia('https://tawk.to/chat/5539675c74c5ad913414efa3/1au8pscbl/?$_tawk_popout=true', 'Chat', 'width=400,height=650,left=300,top=200,toolbar=yes');
        break;
      case VinculosExternos.Videos:
        // window.open('', '_blank');
        break;
      case VinculosExternos.LoNuevo:
        this.vistaPrevia('https://drive.google.com/file/d/1MkqlIx_MRlrKHqPDXncAhEhvec4hTzqL/view?usp=sharing');
        break;
      case VinculosExternos.Documentos:
        this.vistaPrevia('https://drive.google.com/file/d/1S2g76tKZqqvtoyWy6SGkx_C9jELWWhG7/view?usp=sharing');
        break;
    }
  }

  public static crearContentPane(contenidoId: string, encabezado: string, permitirCierrar = true, encabezadoId = '', ocultar = false, permitirFloating = false, permitirDocking = false, permitirMaximizar = false): IgcContentPane {
    return {
      type: IgcDockManagerPaneType.contentPane,
      contentId: contenidoId,
      header: encabezado,
      headerId: encabezadoId,
      hidden: ocultar,
      allowDocking: permitirDocking,
      allowFloating: permitirFloating,
      allowMaximize: permitirMaximizar,
      allowClose: permitirCierrar
    };
  }

  public static validarExisteTabGroupPane(docHostRootPane: IgcSplitPane): IgcTabGroupPane {
    const tabGroup = docHostRootPane.panes.find((p: IgcDockManagerPane) => p.type === IgcDockManagerPaneType.tabGroupPane) as IgcTabGroupPane;
    if (tabGroup) {
      return tabGroup;
    } else {
      const tg: IgcTabGroupPane = {
        type: IgcDockManagerPaneType.tabGroupPane,
        panes: []
      };
      docHostRootPane.panes.push(tg);
      return tg;
    }
  }

  public static getDMSecundarioActivoMaestro(infPpto: AppPresupuestosService): DmSecundarioComponent {
    return (infPpto.esPptoMaestro) ? infPpto.dmPrincipal?.dmSecundarioPptoMaestro : infPpto.dmPrincipal?.dmSecundarioPptoActivo;
  }

  public static getPptoSelectedActivoMaestro(infPpto: AppPresupuestosService): ClsCatalogoPresupuestos {
    return (infPpto.esPptoMaestro) ? infPpto?.pptoSeleccionadoMaestro : infPpto?.pptoSeleccionadoActivo;
  }

  public static getPptoCompletoActivoMaestroJSON(infPpto: AppPresupuestosService): ClsPartidasConceptosExpIns {
    return (infPpto.esPptoMaestro) ? infPpto?.pptoMaestroCompletoJSON : infPpto?.pptoActivoCompletoJSON;
  }

  public static async descomprimirArchivoBase64(data: string, nombreArchivo: string): Promise<string> {
    try {
      const zip = new JSZip();
      const zipData = await zip.loadAsync(data, {base64: true});

      // Buscar la key original que contiene el archivo
      const originalKey = Object.keys(zipData.files)
        .find(key => key.replace(/\0+$/, '') === nombreArchivo);

      if (this.esNulo(originalKey)) {
        // Puedes listar todos los nombres para debug
        console.error('Archivos en el ZIP:', Object.keys(zipData.files));
        // const mensaje = this. objGenerico.getTranslationsMensajes('MENSAJES.ERROR.NO_EXISTE_FILE_ZIP');
        throw new Error(`El archivo "${nombreArchivo}" no existe dentro del ZIP.`);
      }
      const archivo = zipData.file(originalKey);

      if (!archivo) throw new Error(`Archivo ${nombreArchivo} está corrupto`);

      return await archivo.async('string');
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public static async descomprimirArchivoFile(file: any): Promise<JSZip> {
    try {
      const zip = new JSZip();
      return await zip.loadAsync(file).then(zipData => {
        return zipData;
      });
    } catch (e) {
      throw new Error(e.message);
    }
  }

  /**
   * exporta todos o los marcados
   * el metodo detecta si tiene seleccionados y son los que exporta
   * en caso de no tener seleccionados, exporta todos los registros
   * @param grid recibe tipo IgxGridComponent o IgxTreeGridComponent
   * @param nombreArchivo nombre con el que se va a exportar el archivo
   * @param excelExportService API para realizar el exportado
   */
  public static async exportarDatos(grid: IgxGridComponent | IgxTreeGridComponent, nombreArchivo: string, excelExportService: IgxExcelExporterService): Promise<string> {
    let sms: string;
    const rows = grid.selectedRows;
    const exporterOptions: IgxExcelExporterOptions = new IgxExcelExporterOptions(nombreArchivo);
    try {
      // validar si hay datos a exportar
      if (grid.data.length === 0) {
        throw new Error('MENSAJES.ALERT.NO_HAY_DATOS_EXPORTAR');
      }
      exporterOptions.ignoreColumnsVisibility = false;
      exporterOptions.freezeHeaders = true;
      grid.isLoading = true;

      // Determinar cantidad de registros a procesar para optimización
      const countRegistros = rows.length > 0 ? rows.length : grid.data.length;

      // si el numero de registros a exportar es mayor a 10,000
      // cambiamos la bandera de exportSummaries = false para que no sea lento al exportar
      if (countRegistros > 10000) {
        exporterOptions.exportSummaries = false;
      }

      // Suscribirse y desuscribirse inmediatamente para evitar memory leaks
      const sub = excelExportService.exportEnded.subscribe(() => {
        grid.isLoading = false;
        sub.unsubscribe();
      });

      if (rows.length === grid.data.length || rows.length === 0) {
        excelExportService.export(grid, exporterOptions);
      } else {
        const columns = grid.columns.filter(x => !x.hidden);
        const exportData: any[] = [];

        rows.forEach(key => {
          const dataItem = grid.getRowData(key);
          const rowObject: Record<string, any> = {};

          columns.forEach(prop => {
            rowObject[prop.header] = dataItem[prop.field];
          });

          exportData.push(rowObject);
        });

        excelExportService.exportData(exportData, exporterOptions);
      }
      sms = rows.length ? 'MENSAJES.GRALS.NUM_REG_EXPORTAR' : 'MENSAJES.GRALS.TODOS_REG_EXPORTAR';
    } catch (e) {
      grid.isLoading = false;
      throw new Error(e.message);
    }

    return sms;
  }

    /**
   * exporta todos o los marcados
   * el metodo detecta si tiene seleccionados y son los que exporta
   * en caso de no tener seleccionados, exporta todos los registros
   * @param grid recibe tipo IgxGridComponent o IgxTreeGridComponent
   * @param nombreArchivo nombre con el que se va a exportar el archivo
   * @param pdfExportService API para realizar el exportado
   * @param opcionesPDF opciones personalizadas para el PDF
   */
  public static async exportarDatosPDF(grid: IgxGridComponent | IgxTreeGridComponent, nombreArchivo: string, pdfExportService: IgxPdfExporterService, opcionesPDF?: any): Promise<string> {
    const exportData: any[] = [];
    const rows = grid.selectedRows;
    const exporterOptions: IgxPdfExporterOptions = new IgxPdfExporterOptions(nombreArchivo);
    exporterOptions.ignoreColumnsVisibility = false;
    exporterOptions.freezeHeaders = true;
    let sms: string;
    try {
      // validar que tenga registros
      if (grid.data.length === 0) {
        throw new Error('MENSAJES.ALERT.NO_HAY_DATOS_EXPORTAR');
      }
      grid.isLoading = true;
      // si el numero de registros seleccionados o data del grid son mayor a 10,000
      // cambiamos la bandera de exportSummaries = false para que no sea lento al exportar
      if (rows.length === 0 && grid.data.length > 10000) {
        exporterOptions.exportSummaries = false;
      }
      if (rows.length > 10000) {
        exporterOptions.exportSummaries = false;
      }
      // Aplicar opciones personalizadas si se eligen
      if (opcionesPDF) {
        if (opcionesPDF.pageSize) {
          exporterOptions.pageSize = opcionesPDF.pageSize;
        }
        if (opcionesPDF.pageOrientation) {
          exporterOptions.pageOrientation = opcionesPDF.pageOrientation;
        }
        if (opcionesPDF.ignoreColumnsVisibility !== undefined) {
          exporterOptions.ignoreColumnsVisibility = opcionesPDF.ignoreColumnsVisibility;
        }
        if (opcionesPDF.freezeHeaders !== undefined) {
          exporterOptions.freezeHeaders = opcionesPDF.freezeHeaders;
        }
        if (opcionesPDF.exportSummaries !== undefined) {
          exporterOptions.exportSummaries = opcionesPDF.exportSummaries;
        }
        if (opcionesPDF.showTableBorders !== undefined) {
          exporterOptions.showTableBorders = opcionesPDF.showTableBorders;
        }
        if (opcionesPDF.fontSize !== undefined) {
          exporterOptions.fontSize = opcionesPDF.fontSize;
        }
      }
      if (rows.length === grid.data.length || rows.length === 0) {
        pdfExportService.export(grid, exporterOptions);
      } else {
        const columns = grid.columns.filter(x => !x.hidden);

        rows.forEach(key => {
          const dataItem = grid.getRowData(key);
          const rowObject: Record<string, any> = {};

          columns.forEach(prop => {
            rowObject[prop.header] = dataItem[prop.field];
          });

          exportData.push(rowObject);
        });

        pdfExportService.exportData(exportData, exporterOptions);
      }
      // esperamos que termine de generar el archivo a exportar
      pdfExportService.exportEnded.subscribe(() => {
        grid.isLoading = false;
      });
      sms = rows.length ? 'MENSAJES.GRALS.NUM_REG_EXPORTAR' : 'MENSAJES.GRALS.TODOS_REG_EXPORTAR';
    } catch (e) {
      grid.isLoading = false;
      throw new Error(e.message);
    }

    return sms;
  }

  /**
   * abre la ventana de personalización de PDF y exporta con las opciones seleccionadas
   * @param grid grid a exportar
   * @param nombreArchivo nombre del PDF
   * @param pdfExportService servicio para exportar PDF
   * @param crearCompDinamico servicio para crear componentes
   * @param tipoMsg servicio para mostrar mensajes
   * @param mObjGenerico objeto genérico para traducciones
   */
  public static async abrirVentanaPersonalizarPDF(
    grid: IgxGridComponent | IgxTreeGridComponent,
    nombreArchivo: string,
    pdfExportService: IgxPdfExporterService,
    crearCompDinamico: CrearComponenteDinamicoService,
    tipoMsg: TipoMensajesService,
    mObjGenerico: ClsObjGenerico
  ): Promise<void> {
    try {
      const vtnGenerico = crearCompDinamico.crearComponente(VtnGenericaComponent).instance as VtnGenericaComponent;
      vtnGenerico.queVtnEstaAbierta = 'PersonalizarPDF';
      const vtnPersonalizarPDF = vtnGenerico.crearComponente(PersonalizarPdfComponent);
      vtnPersonalizarPDF.vtnGenerico = vtnGenerico;

      vtnPersonalizarPDF.opcionesConfirmadas.subscribe(async (opciones: ClsOpcionesPDF) => {
        try {
          await ClsUtil.exportarDatosPDF(grid, nombreArchivo, pdfExportService, opciones).then(sms => {
            tipoMsg.mostrarToast(mObjGenerico.getTranslationsSmsExportar(sms, grid.selectedRows.length));
          });
        } catch (e) {
          tipoMsg.mostrarMsg(e.message, 'error');
        }
      });

      await vtnPersonalizarPDF.open();
    } catch (e) {
      tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public static quitarAcentos(cadena: string): string {
    const acentos = {á: 'a', é: 'e', í: 'i', ó: 'o', ú: 'u', Á: 'A', É: 'E', Í: 'I', Ó: 'O', Ú: 'U'};
    return cadena.split('').map(letra => acentos[letra] || letra).join('').toString().toUpperCase();
  }

  public static parseNumber(valor: any) {
    const numero = Number(valor);
    return isNaN(numero) ? 0 : this.evaluadorExpresiones(numero);
  }

  /**
   * @param valor valor a validar
   * @param decimales default a 2 decimales
   */
  public static evaluadorExpresiones(valor: any, decimales: number = 2): number {
    let worksheet: Worksheet;
    let workbook: Workbook;
    try {
      workbook = new Workbook(WorkbookFormat.Excel2007);
      workbook.unprotect();
      worksheet = workbook.worksheets().add('Datos');
      workbook.culture = this.obtenerLocalGrid();
      worksheet.rows(0).cells(0).applyFormula('=(' + valor + ')');
      return +worksheet.rows(0).cells(0).value.toFixed(decimales);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  /**
   * Verifica un valor que sea un número, y lo redondea al número de decimales especificado
   * además acepta expresiones tipo excel
   * @param valor Objeto a validar
   * @param requerido Determina si se acepta Nulo como valor
   * @param nombreCampo Nombre del campo que se esta validando para los mensajes de error
   * @param decimales Número de decimales a que se redondea el valor
   * @param objGenerico Obj para obtener el mensaje
   * @param permitirNegativo Determina si se aceptan valores negativos
   * @param permitirCero Determina si se acepta el valor cero
   * @return Devuelve un valor numérico redondeado a N decinales
   */
  public static verificaNumeroConExpresion(valor: any, requerido: boolean, nombreCampo: string, decimales: number, objGenerico: ClsObjGenerico, permitirNegativo: boolean = true, permitirCero: boolean = true): number {
    let resp: number;
    nombreCampo = objGenerico.getTranslationsSubject(nombreCampo);
    if (ClsUtil.esNulo(valor)) {
      if (requerido) {
        throw new Error(objGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CAMPO').replace('{0}', nombreCampo));
      } else {
        return 0;
      }
    } else {
      resp = this.evaluadorExpresiones(valor, decimales);
      if (permitirNegativo) {
        if (!permitirCero && resp === 0) {
          throw new Error(objGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CAMPO_IGUAL_CERO').replace('{0}', nombreCampo));
        }
      } else {
        if (permitirCero) {
          if (resp < 0) {
            throw new Error(objGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CAMPO_MAYOR_IGUAL_CERO').replace('{0}', nombreCampo));
          }
        } else {
          if (resp <= 0) {
            throw new Error(objGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CAMPO_MAYOR_CERO').replace('{0}', nombreCampo));
          }
        }
      }
    }
    return resp;
  }

  public static calcularImporte(cantidad: number, costoPrecio: number, operador: boolean, decimales: number = 2): number {
    return (operador) ? ClsUtil.redondearMoneda(costoPrecio / cantidad, decimales) : ClsUtil.redondearMoneda(costoPrecio * cantidad, decimales);
  }

  public static calcularImporteCadena(cantidad: number, costoPrecio: number, operador: string, decimales: number = 2): number {
    return (operador === '/') ? ClsUtil.redondearMoneda(costoPrecio / cantidad, decimales) : ClsUtil.redondearMoneda(costoPrecio * cantidad, decimales);
  }

  public static calcularCantidad(importe: number, costoPrecio: number, operador: string, decimales: number = 2): number {
    return (operador === '/') ? ClsUtil.redondearMoneda(costoPrecio / importe, decimales) : ClsUtil.redondearMoneda(importe / costoPrecio, decimales);
  }

  public static mergePresupuestoMatrices(ppto: ClsPartidasConceptosExpIns, infPpto: AppPresupuestosService, mapHExpXConcepto: Map<bigint, ClsCalculoDetalleExpXConcepto[]>, tipoMonedaCalcular: number): MergeResult {
    let mapEncabezado = new Map<bigint, Map<bigint, number>>;
    let mapEncabezado2 = new Map<bigint, Map<number, IProgSumExplosionDetalle>>;
    try {
      if (this.esNulo(ppto.Partidas) || this.esNulo(ppto.Presupuesto)) {
        return { mapEncabezado, mapEncabezado2 };
      }
      const decimalExp = infPpto.decimalredondearexpins;
      const decimalImp = infPpto.decimalredondearimporte;

      // 1️⃣ Indexar matrices y conceptos
      const mapaConceptos: Map<bigint, ClsConceptosPartida[]> = this.crearMapPresupuestoIdPptoPartida(ppto.Presupuesto, decimalImp);

      // 🚀 2. Loop principal optimizado
      const partidas = ppto.Partidas;
      const costoConcepto = (c: ClsConceptosPartida): number => tipoMonedaCalcular === 1 ? c.CostoMoneda2 : c.CostoMoneda1;

      for (let i = 0; i < partidas.length; i++) {
        const partida = partidas[i];

        const conceptos = mapaConceptos.get(partida.IdPresupuestoPartida);
        if (!conceptos || conceptos.length === 0) continue;

        const mapAcumulado = new Map<bigint, number>();
        const mapConcepto = new Map<number, IProgSumExplosionDetalle>();

        for (let j = 0; j < conceptos.length; j++) {
          const concepto = conceptos[j];

          const analisis = mapHExpXConcepto.get(concepto.IdCatalogo);
          if (!analisis || analisis.length === 0) continue;

          mapConcepto.set(concepto.Control, { IdCatalogo: concepto.IdCatalogo?.toString(), Cantidad: concepto.Cantidad, Costo: costoConcepto(concepto) });

          for (let k = 0; k < analisis.length; k++) {
            const item = analisis[k];
            const key = item.IdCatalogo;
            const prev = mapAcumulado.get(key);

            if (!ClsUtil.esNulo(prev)) {
              mapAcumulado.set(key, ClsUtil.redondear(prev + item.Expins, decimalExp));
            } else {
              mapAcumulado.set(key, item.Expins);
            }
          }
        }

        mapEncabezado2.set(partida.IdPresupuestoPartida, mapConcepto);
        mapEncabezado.set(partida.IdPresupuestoPartida, mapAcumulado);
      }
    } catch (e) {
      throw new Error(e.message);
    }

    // ✅ ordenar ambos mapas
    const sorted1 = new Map(
      [...mapEncabezado.entries()].sort((a, b) =>
        a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0
      )
    );

    const sorted2 = new Map(
      [...mapEncabezado2.entries()].sort((a, b) =>
        a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0
      )
    );

    return {mapEncabezado: sorted1, mapEncabezado2: sorted2};
  }

  /**
   * Funcion que regresa presupueto completo
   * @param ppto
   * @param infPpto
   * @param generarNiveles
   * @param regresarIDString regresa los ids en string
   */

  public static mergePartidasConceptos(ppto: ClsPartidasConceptosExpIns, infPpto: AppPresupuestosService, generarNiveles: boolean = false, regresarIDString: boolean = false): IPptoCompleto[] {
    const resultado: IPptoCompleto[] = [];
    let total1 = 0;
    let total2 = 0;
    const decimal = infPpto.decimalredondearimporte;
    try {
      if (this.esNulo(ppto.Partidas) || this.esNulo(ppto.Presupuesto)) {
        return resultado;
      }
      // 1️⃣ Indexar conceptos por partida
      const mapaConceptos: Map<bigint, ClsConceptosPartida[]> = this.crearMapPresupuestoIdPptoPartida(ppto.Presupuesto, decimal);

      // 2️⃣ Mezclar partidas y conceptos
      for (const partida of ppto.Partidas) {
        const conceptos = mapaConceptos.get(partida.IdPresupuestoPartida) ?? [];
        for (const concepto of conceptos) {
          // 📌 Crear el objeto completo
          const pptoCompleto: IPptoCompleto = {
            Marca: concepto.Marca,
            CantidadACopiar: '',

            ...(regresarIDString
                ? {
                  IdPartidaPadreS: partida.IdPartidaPadre.toString(),
                  IdPresupuestoPartidaS: partida.IdPresupuestoPartida.toString(),
                  IdCatalogoS: concepto.IdCatalogo.toString()
                }
                : {
                  IdPartidaPadre: partida.IdPartidaPadre,
                  IdPresupuestoPartida: partida.IdPresupuestoPartida,
                  IdCatalogo: concepto.IdCatalogo
                }
            ),

            PartidaWBS: partida.PartidaWBS,
            Partida: partida.Partida,
            PartidaAuxiliar: partida.PartidaAuxiliar,
            DescripcionPartida: partida.DescripcionPartida,
            DescripcionPartidaLarga: partida.DescripcionPartidaLarga,

            Nivel: concepto.Nivel,
            Control: concepto.Control,
            Renglon: concepto.Renglon,
            Codigo: concepto.Codigo,
            CodigoAuxiliar: concepto.CodigoAuxiliar,
            Descripcion: concepto.Descripcion,
            DescripcionLarga: concepto.DescripcionLarga,
            Unidad: concepto.Unidad,
            TipoInsumo: concepto.TipoInsumo,
            Cantidad: concepto.Cantidad,
            CostoMoneda1: concepto.CostoMoneda1,
            CostoMoneda2: concepto.CostoMoneda2,
            PrecioMoneda1: concepto.PrecioMoneda1,
            PrecioMoneda2: concepto.PrecioMoneda2,

            ImporteMoneda1: this.redondearMoneda(concepto.Cantidad * concepto.PrecioMoneda1, decimal),
            ImporteMoneda2: this.redondearMoneda(concepto.Cantidad * concepto.PrecioMoneda2, decimal),

            IndirectoEspecial: concepto.IndirectoEspecial,
            PorcentajeIndirectoEspecial: concepto.PorcentajeIndirectoEspecial,

            PorcentajeDeParticipacion1: 0,
            PorcentajeDeParticipacion2: 0,
            AcumuladoPorParticipacion1: 0,
            AcumuladoPorParticipacion2: 0,

            UrlContenido: concepto.UrlContenido,
            PendienteAnalizar: concepto.PendienteAnalizar,
            ObservacionPendiente: concepto.ObservacionPendiente,
            EsPorcentaje: concepto.EsPorcentaje,
            EsCostoHorario: concepto.EsCostoHorario
          };

          total1 = this.redondear(total1 + pptoCompleto.ImporteMoneda1, decimal);
          total2 = this.redondear(total2 + pptoCompleto.ImporteMoneda2, decimal);
          resultado.push(generarNiveles ? this.agregarNivelesPartidas(pptoCompleto, infPpto) : pptoCompleto);
        }
        // 3️⃣ Asignar % participación
        for (const row of resultado) {
          row.PorcentajeDeParticipacion1 = (total1 === 0) ? 0 : row.ImporteMoneda1 / total1;
          row.PorcentajeDeParticipacion2 = (total2 === 0) ? 0 : row.ImporteMoneda2 / total2;
        }
      }
    } catch (e) {
      throw new Error(e.message);
    }
    return resultado;
  }

  /**
   * Suma importes de conceptos por partida (Cantidad × Costo/Precio, redondeo por línea).
   * CostoMoneda* / PrecioMoneda* del resultado = totales de importe para el reporte resumen.
   */
  public static sumarCostoPrecioConceptosResumenPresupuesto(conceptos: ClsConceptosPartida[],
                                                            decimalImporte: number): Pick<ClsArbolPartida, 'CostoMoneda1' | 'PrecioMoneda1' | 'CostoMoneda2' | 'PrecioMoneda2'> {
    let costoMoneda1 = 0;
    let precioMoneda1 = 0;
    let costoMoneda2 = 0;
    let precioMoneda2 = 0;

    for (const concepto of conceptos) {
      const cantidad = concepto.Cantidad ?? 0;

      const importeCosto1 = this.calcularImporte(cantidad, concepto.CostoMoneda1 ?? 0, false, decimalImporte);
      const importePrecio1 = this.calcularImporte(cantidad, concepto.PrecioMoneda1 ?? 0, false, decimalImporte);
      const importeCosto2 = this.calcularImporte(cantidad, concepto.CostoMoneda2 ?? 0, false, decimalImporte);
      const importePrecio2 = this.calcularImporte(cantidad, concepto.PrecioMoneda2 ?? 0, false, decimalImporte);

      costoMoneda1 = this.redondearMoneda(costoMoneda1 + importeCosto1, decimalImporte);
      precioMoneda1 = this.redondearMoneda(precioMoneda1 + importePrecio1, decimalImporte);
      costoMoneda2 = this.redondearMoneda(costoMoneda2 + importeCosto2, decimalImporte);
      precioMoneda2 = this.redondearMoneda(precioMoneda2 + importePrecio2, decimalImporte);
    }

    return {CostoMoneda1: costoMoneda1, PrecioMoneda1: precioMoneda1, CostoMoneda2: costoMoneda2, PrecioMoneda2: precioMoneda2};
  }

  public static asignarCostoPrecioPartidaDesdeConceptosResumen(partida: ClsArbolPartida,
                                                               mapaConceptos: Map<bigint, ClsConceptosPartida[]>,
                                                               decimalImporte: number): ClsArbolPartida {
    const conceptos = mapaConceptos.get(this.bigintX(partida.IdPresupuestoPartida)) ?? [];
    return {...partida, ...this.sumarCostoPrecioConceptosResumenPresupuesto(conceptos, decimalImporte)};
  }

  public static agregarNivelesPartidas(pptoCompleto: IPptoCompleto, infPpto: AppPresupuestosService): IPptoCompleto {
    const processedRecords: Map<any, ITreeGridRecord> = infPpto.dmPrincipal.dmSecundarioPptoActivo.Ppto.partidaComponent.treeGridPartidas.processedRecords;
    const niveles: ClsArbolPartidaNiveles[] = [];
    // Llenar arreglo niveles de forma ascendente (Nivel más alto al final)
    this.verificarPartidaPadre(pptoCompleto.IdPresupuestoPartida, niveles, processedRecords);
    const totalNiveles : number = niveles.length;
    // Recorremos dinámicamente y asignamos campos Nivel1...Nivel9
    for (let i = 0; i < totalNiveles; i++) {
      const nivel = totalNiveles - i; // ej: si hay 5 niveles: 5,4,3,2,1
      const data = niveles[i];

      // Construimos nombres de propiedad dinámicamente
      (pptoCompleto as any)[`Nivel${nivel}`] = data.Partida;
      (pptoCompleto as any)[`DescripcionLargaNivel${nivel}`] = data.DescripcionPartidaLarga;
      (pptoCompleto as any)[`DescripcionCortaNivel${nivel}`] = data.DescripcionPartida;
    }
    return pptoCompleto;
  }

  public static agregarNivelesAncestrosResumenPresupuesto(partida: IPptoCompleto, infPpto: AppPresupuestosService): IPptoCompleto {
    const processedRecords: Map<any, ITreeGridRecord> = infPpto.dmPrincipal.dmSecundarioPptoActivo.Ppto.partidaComponent.treeGridPartidas.processedRecords;
    const ancestros: ClsArbolPartidaNiveles[] = [];

    if (!this.esNulo(partida.IdPartidaPadre) && partida.IdPartidaPadre !== BigInt('0')) {
      this.verificarPartidaPadre(partida.IdPartidaPadre, ancestros, processedRecords);
    }

    const resultado = {...partida};
    const totalNiveles = ancestros.length;
    for (let i = 0; i < totalNiveles; i++) {
      const nivel = totalNiveles - i;
      const data = ancestros[i];
      (resultado as any)[`Nivel${nivel}`] = data.Partida;
      (resultado as any)[`DescripcionLargaNivel${nivel}`] = data.DescripcionPartidaLarga;
      (resultado as any)[`DescripcionCortaNivel${nivel}`] = data.DescripcionPartida;
    }
    return resultado;
  }

  public static verificarPartidaPadre(IdPresupuestoPartida: bigint, niveles: ClsArbolPartidaNiveles[], processedRecords: Map<any, ITreeGridRecord>) {
    const partida: ClsArbolPartida = processedRecords.get(IdPresupuestoPartida).data;
    niveles.push({
      Partida: partida.Partida,
      DescripcionPartida: partida.DescripcionPartida,
      DescripcionPartidaLarga: partida.DescripcionPartidaLarga
    });
    if (partida.IdPartidaPadre !== BigInt('0')) {
      this.verificarPartidaPadre(partida.IdPartidaPadre, niveles, processedRecords);
    }
  }

  // public static copiarDatos(data) {
  //   const tempElement = document.createElement('input');
  //   document.body.appendChild(tempElement);
  //   tempElement.setAttribute('id', 'temp_id');
  //   (document.getElementById('temp_id') as HTMLInputElement).value = data;
  //   tempElement.select();
  //   document.execCommand('copy');
  //   document.body.removeChild(tempElement);
  // }

  public static tipoPresupuesto(tipo: number): string {
    let tp = '';
    switch (tipo) {
      case 1:
        tp = 'MENSAJES.GRALS.TPPROPIOS';
        break;
      case 2:
        tp = 'MENSAJES.GRALS.TPPUBLICOS';
        break;
      case 3:
        tp = 'MENSAJES.GRALS.TPCOMPARTIDOS';
        break;
      case 4:
        tp = '03_Maestros_Construbase®';
        break;
    }
    return tp;
  }

  public static nivelAcceso(tipo: number): string {
    let nivel = '';
    switch (tipo) {
      case 0:
        nivel = 'MENSAJES.GRALS.NALECTURAESCRITURA';
        break;
      case 1:
        nivel = 'MENSAJES.GRALS.NALECTURA';
        break;
      case 2:
        nivel = 'MENSAJES.GRALS.NAESCRITURA';
        break;
    }
    return nivel;
  }

  public static generarID(): string {
    return uuidv4();
  }

  /**
   * Genera un ID negativo único de forma automática.
   * No requiere reseteo manual y soporta cargas masivas (>100k).
   */
  public static generarIDNegativo(): number {
    const ahora = Date.now();

    // Si seguimos en el mismo milisegundo, incrementamos el contador
    if (ahora === this.ultimoMilisegundo) {
      this.contador++;
    } else {
      // Si cambió el milisegundo, reiniciamos el contador interno
      this.ultimoMilisegundo = ahora;
      this.contador = 0;
    }

    /* Combinamos:
       1. El tiempo actual (asegura unicidad entre sesiones/momentos)
       2. El contador (asegura unicidad dentro de bucles rápidos)
       Todo multiplicado por -1 para asegurar que sea negativo.
    */
    return (ahora + this.contador) * -1;
  }

  public static generarIDNumber(): number {
    // Returns a random integer from -10000 to -200000
    return Math.floor(Math.random() * -200000) - 10000;
  }

  // public static generarIDBigInt(): bigint {
  //   return BigInt(Date.now()) * BigInt(Number.MAX_SAFE_INTEGER) +
  //     BigInt(Math.floor(Number.MAX_SAFE_INTEGER * Math.random()));
  // }

  public static generarRenglon(data: any[]): number {
    try {
      if (data.length === 0) {
        return 10;
      }
      // Encuentra el valor máximo de Renglon en el array
      const maxRenglon = Math.max(...data.map(item => item.Renglon));

      // Devuelve el siguiente valor de Renglon
      return maxRenglon + 10;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public static cambiarPptoActivoAMaestroExpInsumoAcoplado(cambioMaestro: boolean, infPpto: AppPresupuestosService): ClsCatalogosExpIns[] {
    try {
      if (cambioMaestro) {
        if (this.esNulo(infPpto.pptoMaestroCompletoJSON.CatExpIns)) {
          throw new Error('MENSAJES.ERROR.NO_SELECT_PPTO_MAESTRO');
        }
        // if (infPpto.pptoMaestroCompletoJSON.CatExpIns.length === 0) {
        //   throw new Error('MENSAJES.ERROR.NO_TIENE_EXP_INS');
        // }
        if (infPpto.pptoMaestroCompletoJSON.CatExpIns.length > 0) {
          return infPpto.pptoMaestroCompletoJSON.CatExpIns;
        }
      } else {
        return infPpto.pptoActivoCompletoJSON.CatExpIns;
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public static crearMapIdMatriz(objMatriz: ClsMatriz[]): Map<bigint, ClsMatriz> {
    const map = new Map<bigint, ClsMatriz>();

    for (const item of objMatriz) {
      const id = this.bigintX(item.IdCodigoMatriz);
      item.IdCodigoMatriz = id;          // Si necesitas conservar el bigint
      map.set(id, item);
    }

    return map;
  }

  public static crearMapIdCatalogo(objCatalogo: any[]): Map<bigint, any> {
    const map = new Map<bigint, any>();

    for (const item of objCatalogo) {
      const id = this.bigintX(item.IdCatalogo);
      item.IdCatalogo = id;          // Si necesitas conservar el bigint
      map.set(id, item);
    }

    return map;
  }

  public static crearMapCatalogoCodigo(objCatalogo: ClsCatalogosExpIns[]): Map<string, ClsCatalogosExpIns> {
    const map = new Map<string, ClsCatalogosExpIns>();

    for (const item of objCatalogo) {
      map.set(item.Codigo, item);
    }

    return map;
  }

  public static crearMapPresupuestoIdPptoPartida(objPresupuesto: ClsConceptosPartida[], _DECIMALREDONDEARIMPORTE: number): Map<bigint, ClsConceptosPartida[]> {
    const map = new Map<bigint, ClsConceptosPartida[]>();
    for (const item of objPresupuesto) {
      const key = this.bigintX(item.IdPresupuestoPartida);

      item.ImporteMoneda1 = this.calcularImporte(item.Cantidad, item.PrecioMoneda1, false, _DECIMALREDONDEARIMPORTE);
      item.ImporteMoneda2 = this.calcularImporte(item.Cantidad, item.PrecioMoneda2, false, _DECIMALREDONDEARIMPORTE);

      // Obtiene el array correspondiente en el mapa o crea uno nuevo
      const arrayPpto = map.get(key) || [];
      arrayPpto.push(item);
      // Actualiza el mapa con el array modificado
      map.set(key, arrayPpto);
    }

    return map;
  }

  public static ordenarMapXNivel(MapCatalogo: Map<bigint, ClsCalculoCatalogo>): ClsCalculoOrderNivel[] {
    let arr: ClsCalculoOrderNivel[] = [];
    // Iteramos MapCatalogo para crear el nuevo Obj ClsCalculoOrderNivel[], para poder ser ordenado
    for (const [key, cat] of MapCatalogo) {
      arr.push({IdCatalogo: this.bigintX(key), Nivel: cat.Nivel});
    }
    // ordenamos por Nivel
    arr = arr.sort((a, b) => a.Nivel - b.Nivel);

    return arr;
  }

  public static ordenarMapXNivelDesc(MapCatalogo: Map<bigint, ClsCalculoCatalogo>): ClsCalculoOrderNivel[] {
    let arr: ClsCalculoOrderNivel[] = [];
    // Iteramos MapCatalogo para crear el nuevo Obj ClsCalculoOrderNivel[], para poder ser ordenado
    for (const [key, cat] of MapCatalogo) {
      if (cat.Nivel > 0) {
        arr.push({IdCatalogo: this.bigintX(key), Nivel: cat.Nivel});
      }
    }
    // ordenamos por Nivel
    arr = arr.sort((a, b) => b.Nivel - a.Nivel);

    return arr;
  }

  public static sortWBS(d) {
    const sort = {
      asc(a, b) {
        let l = 0, m = Math.min(a.value.length, b.value.length);
        while (l < m && a.value[l] === b.value[l]) {
          l++;
        }
        return l === m ? a.value.length - b.value.length : a.value[l] - b.value[l];
      }
    }, mapped = d.map((el, i) => ({index: i, value: el.PartidaWBS.split('.').map(Number)}));
    mapped.sort(sort.asc);
    return mapped.map(el => d[el.index]);
  }

  public static async descomprimirPptoSeleccionado(respuesta: ClsRespuestaPresupuestos, objExpInsumos: ClsObjExplosionDeInsumos, objPresupuestoPartida: ClsObjPresupuestoPartidas,
                                                   objPresupuesto: ClsObjPresupuesto, objCalculo: ClsObjCalculo, objCostoHorarios: ClsObjCostoHorario, objMatrices: ClsObjMatrices, pptoSeleccionado: ClsCatalogoPresupuestos,
                                                   infPpto: AppPresupuestosService, esMaestro: boolean, updateBanderas: boolean, cerrarBusqGral = true) {
    let dmSecundario: DmSecundarioComponent;
    let objCatalogo: ClsCatalogosExpIns[] = [];
    let objPartidas: ClsArbolPartida[] = [];
    let objPpto: ClsConceptosPartida[] = [];
    let objCH: ClsCostoHorarios[] = [];
    let objMat: ClsMatriz[] = [];
    let objCostos: ClsCatalogoCostosCalculo[] = [];
    let objCostosOP: ClsCatalogoCostosOPCalculo[] = [];
    let objCostosMO: ClsCatalogoMOCalculo[] = [];
    let mapCatalogo: Map<bigint, ClsCatalogosExpIns>;
    try {
      if (!ClsUtil.esNulo(respuesta.Catalogo)) {
        objCatalogo = await objExpInsumos.crearObjCatalogos(respuesta.Catalogo);
        mapCatalogo = this.crearMapIdCatalogo(objCatalogo);
      }
      if (!ClsUtil.esNulo(respuesta.Partidas)) {
        objPartidas = await objPresupuestoPartida.crearObjPartidas(respuesta.Partidas);
      }
      if (!ClsUtil.esNulo(respuesta.Presupuesto)) {
        objPpto = await objPresupuesto.crearObjPresupuesto(respuesta.Presupuesto, mapCatalogo);
      }
      if (!ClsUtil.esNulo(respuesta.CostosHorarios)) {
        objCH = await objCostoHorarios.crearObjCostosHorarios(respuesta);
      }
      if (!ClsUtil.esNulo(respuesta.Matrices)) {
        objMat = await objMatrices.crearObjMatrices(respuesta.Matrices);
      }
      if (!ClsUtil.esNulo(respuesta.CostosCalculo)) {
        objCostos = await objCalculo.crearObjCostosCalculo(respuesta.CostosCalculo);
      }
      if (!ClsUtil.esNulo(respuesta.CostosOP)) {
        objCostosOP = await objCalculo.crearObjCostosOPCalculo(respuesta.CostosOP);
      }
      if (!ClsUtil.esNulo(respuesta.CostosMO)) {
        objCostosMO = await objCalculo.crearObjCostosMOCalculo(respuesta.CostosMO);
      }
      // Asignar valores e iniciar como maestro (todo de lectura)
      if (esMaestro) {
        if (updateBanderas) {
          infPpto.dmPrincipal.ocultarComponentesPptoMaestro(false);
        }
        infPpto.pptoSeleccionadoMaestro = pptoSeleccionado;
        infPpto.pptoMaestroCompletoJSON.Partidas = objPartidas;
        infPpto.pptoMaestroCompletoJSON.Presupuesto = objPpto;
        infPpto.pptoMaestroCompletoJSON.CatExpIns = objCatalogo;
        infPpto.pptoMaestroCompletoJSON.Matrices = objMat;
        infPpto.pptoMaestroCompletoJSON.CostoHorarios = objCH;
        infPpto.pptoMaestroCompletoJSON.CostosCalculo = objCostos;
        infPpto.pptoMaestroCompletoJSON.CostosOPCalculo = objCostosOP;
        infPpto.pptoMaestroCompletoJSON.CostosMOCalculo = objCostosMO;
      } else {
        if (updateBanderas) {
          infPpto.dmPrincipal.ocultarComponentesPptoActivo(false, cerrarBusqGral);
        }
        infPpto.pptoSeleccionadoActivo = pptoSeleccionado;
        infPpto.pptoActivoCompletoJSON.Partidas = objPartidas;
        infPpto.pptoActivoCompletoJSON.Presupuesto = objPpto;
        infPpto.pptoActivoCompletoJSON.CatExpIns = objCatalogo;
        infPpto.pptoActivoCompletoJSON.Matrices = objMat;
        infPpto.pptoActivoCompletoJSON.CostoHorarios = objCH;
        infPpto.pptoActivoCompletoJSON.CostosCalculo = objCostos;
        infPpto.pptoActivoCompletoJSON.CostosOPCalculo = objCostosOP;
        infPpto.pptoActivoCompletoJSON.CostosMOCalculo = objCostosMO;
      }

      await infPpto.dmPrincipal.crearTabDockManager(ClsUtil.crearContentPane(esMaestro ? EnumMenuOpIDPrincipal.PptoMaestro : EnumMenuOpIDPrincipal.PptoActivo, '', true, '', false, true, true));
      dmSecundario = this.getDMSecundarioActivoMaestro(infPpto);
      await dmSecundario.crearTabDockManager(ClsUtil.crearContentPane(EnumMenuOpIDPpto.Presupuesto, 'Presupuesto', false, 'MENSAJES.GRALS.PPTO'));
      dmSecundario.Ppto.dataPartidasConceptos = esMaestro ? infPpto.pptoMaestroCompletoJSON : infPpto.pptoActivoCompletoJSON;
      dmSecundario.Ppto.partidaComponent.partidaSeleccionado = new ClsArbolPartida();
      dmSecundario.Ppto.inicializarComoMaestro(esMaestro);
      dmSecundario.Ppto.partidaComponent.dataPartidasConceptos = dmSecundario.Ppto.dataPartidasConceptos;
      if (!ClsUtil.esNulo(dmSecundario.ExpInsumo)) {
        dmSecundario.ExpInsumo.dataExpIns = objCatalogo;
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public static base64url_encode(str) {
    const utf8str = unescape(encodeURIComponent(str));
    return this.base64_encode_data(utf8str, utf8str.length, this.b64u);
  }

  public static base64_encode_data(data: any, len: any, b64x: any): string {
    let dst = '';
    let i;

    for (i = 0; i <= len - 3; i += 3) {
      dst += b64x.charAt(data.charCodeAt(i) >>> 2);
      dst += b64x.charAt(((data.charCodeAt(i) & 3) << 4) | (data.charCodeAt(i + 1) >>> 4));
      dst += b64x.charAt(((data.charCodeAt(i + 1) & 15) << 2) | (data.charCodeAt(i + 2) >>> 6));
      dst += b64x.charAt(data.charCodeAt(i + 2) & 63);
    }

    if (len % 3 == 2) {
      dst += b64x.charAt(data.charCodeAt(i) >>> 2);
      dst += b64x.charAt(((data.charCodeAt(i) & 3) << 4) | (data.charCodeAt(i + 1) >>> 4));
      dst += b64x.charAt(((data.charCodeAt(i + 1) & 15) << 2));
      dst += this.b64pad;
    } else if (len % 3 == 1) {
      dst += b64x.charAt(data.charCodeAt(i) >>> 2);
      dst += b64x.charAt(((data.charCodeAt(i) & 3) << 4));
      dst += this.b64pad;
      dst += this.b64pad;
    }

    return dst;
  }

  public static removeHtmlTags(html: string): string {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  }

  public static generarRawToHtml(html: string, data: ClsDataEnvioCorreo = {}, tituloCorreo: string, provLogin: ProveedorLogin): ClsEnviarCorreo {
    let strDataEnviarCorreo = '';
    let clsECorreo: ClsEnviarCorreo;
    let clsParametros: ClsParametrosEnviaCorreo;
    const archivos: ClsArchivoBase64[] = data.archivosAdjuntos;

    if (provLogin === ProveedorLogin.Google) {
      strDataEnviarCorreo = `From: ${tituloCorreo} <${data.from}>\n`;
      strDataEnviarCorreo += `To: ${data.to}\n`;
      if (!this.esNulo(data.cc)) {
        strDataEnviarCorreo += `Cc: ${data.cc}\n`;
      }
      if (!this.esNulo(data.bcc)) {
        strDataEnviarCorreo += `Bcc: ${data.bcc}\n`;
      }
      strDataEnviarCorreo += `Subject: =?utf-8?B?${this.base64url_encode(data.subject)}?=\n`;
      strDataEnviarCorreo += `MIME-Version: 1.0\n`;
      if (archivos.length > 0) {
        strDataEnviarCorreo += 'Content-Type: multipart/related; boundary="RelatedBoundaryString"\n\n';
        strDataEnviarCorreo += `--RelatedBoundaryString\n`;
        strDataEnviarCorreo += 'Content-Type: multipart/alternative; boundary="AlternativeBoundaryString"\n\n';
        strDataEnviarCorreo += `--AlternativeBoundaryString\n`;
        strDataEnviarCorreo += 'Content-Type: text/html; charset=UTF-8\n\n';
        strDataEnviarCorreo += `${html}\n\n`;
        strDataEnviarCorreo += `--AlternativeBoundaryString--\n\n`;
        let charSet = '';
        archivos.forEach(ele => {
          strDataEnviarCorreo += `--RelatedBoundaryString\n`;
          if (ele.type === '') {
            ele.type = 'application/octet-stream';
          }
          if (ele.type === 'text/xml') {
            ele.type = 'application/xml';
          }
          if (ele.type.indexOf('text') !== -1) {
            charSet = '; charset=UTF-8\n';
          } else {
            charSet = '\n';
          }
          strDataEnviarCorreo += `Content-Type: ${ele.type}${charSet}`;
          strDataEnviarCorreo += `Content-Transfer-Encoding: base64\n`;
          strDataEnviarCorreo += `Content-Disposition: attachment; filename="${ele.name}"\n\n`;
          strDataEnviarCorreo += `${ele.base64}\n\n`;
        });
        strDataEnviarCorreo += `--RelatedBoundaryString--`; // indica que finaliza los archivos adjuntos
      } else {
        strDataEnviarCorreo += `Content-Type: multipart/alternative; boundary="AlternativeBoundaryString"\n\n`;
        strDataEnviarCorreo += `--AlternativeBoundaryString\n`;
        strDataEnviarCorreo += 'Content-Type: text/html; charset=UTF-8\n\n';
        strDataEnviarCorreo += `${html}\n\n`;
        strDataEnviarCorreo += `--AlternativeBoundaryString--`;
      }
      clsECorreo = {
        accessToken: data.accessToken,
        Raw: this.base64url_encode(strDataEnviarCorreo)
      };
    }

    if (provLogin === ProveedorLogin.Microsoft) {
      const arrToEnviar: string[] = [];
      const arrCcEnviar: string[] = [];
      const arrBccEnviar: string[] = [];
      const arrAdjuntos: ClsAdjuntos[] = [];

      if (!this.esNulo(data.to)) {
        data.to.split(',').forEach(para => {
          arrToEnviar.push(para);
        });
      }
      if (!this.esNulo(data.cc)) {
        data.cc.split(',').forEach(cc => {
          arrCcEnviar.push(cc);
        });
      }
      if (!this.esNulo(data.bcc)) {
        data.bcc.split(',').forEach(bcc => {
          arrBccEnviar.push(bcc);
        });
      }

      if (archivos.length > 0) {
        archivos.forEach(file => {
          const adjunto: ClsAdjuntos = {
            nombreArchivo: file.name,
            tipoArchivo: file.type,
            contenidoBytes: file.base64.toString()
          };
          arrAdjuntos.push(adjunto);
        });
      }

      clsParametros = {
        para: arrToEnviar,
        cc: arrCcEnviar,
        bcc: arrBccEnviar,
        subject: tituloCorreo,
        mensaje: html,
        adjuntos: arrAdjuntos
      };
      clsECorreo = {
        accessToken: data.accessToken,
        parametrosEnvia: clsParametros
      };
    }
    return clsECorreo;
  }

  public static splitTabsNeo(contenido: string): string[] {
    return contenido.split(this.TABNEO);
  }

  public static splitEnterNeo(contenido: string): string[] {
    return contenido.split(this.ENTERNEO);
  }

  public static splitTabs(contenido: string): string[] {
    return contenido.split(this.TAB);
  }

  public static parseFloatSafe(value: string): number {
    if (this.esNulo(value)) {
      return 0;
    }
    const parsed = parseFloat(value.toString().trim());
    return Number.isFinite(parsed) ? parsed : 0;
  }

  public static obtenerValoresM1(json: string): [number, number, number, number, number, number] {
    if (this.esNulo(json)) {
      return [0, 0, 0, 0, 0, 0];
    }

    const valores = json.split(this.TAB);
    return [
      this.parseFloatSafe(valores[0]),
      this.parseFloatSafe(valores[1]),
      this.parseFloatSafe(valores[2]),
      this.parseFloatSafe(valores[3]),
      this.parseFloatSafe(valores[4]),
      this.parseFloatSafe(valores[5])
    ];
  }

  public static splitEnter(contenido: string): string[] {
    return contenido.split(this.ENTER);
  }

  // public static compararArreglo(array1: string[], array2: string[]): boolean {
  //   if (array1.length !== array2.length) { return false; }
  //   for (let i = 0, len = array1.length; i < len; i++){
  //     if (array1[i] !== array2[i]){
  //       return false;
  //     }
  //   }
  //   return true;
  // }

  public static async validarAIZIPTXT(file: any): Promise<boolean> {
    const datosMinimosValidar = ['03-DatosObra.txt', '17-Catalogo.txt', '15-TipoInsumos.txt', '05-Unidades.txt'];
    const datosAValidar: string[] = [];
    const zip: JSZip = await this.descomprimirArchivoFile(file);
    zip.forEach(zipEntry => {
      datosAValidar.push(zipEntry);
    });
    for (let i = 0, len = datosMinimosValidar.length; i < len; i++) {
      if (datosAValidar.indexOf(datosMinimosValidar[i]) === -1) {
        return true;
      }
    }
    return false;
  }

  public static getTranslations(key: string | string[], infApp: AppInfoService): Promise<any> {
    let resultado: any;
    infApp.translate.get(key).subscribe(translations => {
      resultado = translations;
    });
    return resultado;
  }

  public static async getTranslationsMenus(key: string | string[], infApp: AppInfoService): Promise<any> {
    return new Promise(resolve => {
      infApp.translate.get(key).subscribe(translations => {
        resolve(translations);
      });
    });
  }

  public static ajustarTexto(clicked: boolean): { themesClass: string, clicked: boolean } {
    return (clicked) ? {themesClass: 'ajustarTexto', clicked: !clicked} : {
      themesClass: 'noAjustarTexto',
      clicked: !clicked
    };
  }

  public static async convertBlobOrFileToBase64String(blobOrFile: any) {
    const reader = new FileReader();
    reader.readAsDataURL(blobOrFile);
    return new Promise(resolve => {
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  }

  public static descargarArchivo(blob: Blob, nombreArchivo: string) {
    saveAs(blob, nombreArchivo);
  }

  public static decargarArchivoBase64(archivo: string, nombreArchivo: string, tipo: string) {
    const blob: Blob = ClsUtil.convertBase64StringToBlob(archivo, tipo);
    ClsUtil.descargarArchivo(blob, nombreArchivo);
  }

  public static convertBase64StringToBlob(base64: string, tipo: string): Blob {
    // let ruta2: string;
    // ruta2 = ruta.split(',')[1];
    // if (ClsUtil.esNulo(ruta2)) {
    //   ruta2 = ruta;
    // }
    // const byteString = atob(ruta2);
    // const ab = new ArrayBuffer(byteString.length);
    // const ia = new Uint8Array(ab);
    //
    // for (let i = 0; i < byteString.length; i++) {
    //   ia[i] = byteString.charCodeAt(i);
    // }
    // return new Blob([ab], {type: tipo});

    const commaIndex = base64.indexOf(',');
    const cleanBase64 = commaIndex >= 0 ? base64.slice(commaIndex + 1) : base64;

    const byteString = atob(cleanBase64);
    const len = byteString.length;

    const u8arr = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      u8arr[i] = byteString.charCodeAt(i);
    }

    return new Blob([u8arr], { type: tipo });
  }

  public static convertPorcentaje(valor: number) {
    if (ClsUtil.esNulo(valor)) {
      valor = 0;
    }
    return (valor / 100);
  }

  /**
   * @param dato valor a redondear
   * @param decimales default a 2 decimales
   */
  public static redondearMoneda(dato: number, decimales: number = 2): number {
    return +(dato + .00000001).toFixed(decimales);
  }

  public static redondear6Decimales(dato: number, decimales: number = 2): number {
    return +(dato + .000001).toFixed(decimales);
  }

  public static redondear(dato: number, decimales: number): number {
    return +dato.toFixed(decimales);
  }

  public static validarCampoVacioStartsWith(valor: any, objGenerico: ClsObjGenerico, campo: string) {
    try {
      valor = valor.toString();
      this.validarCampoVacio(valor, objGenerico, campo);
      if (valor.startsWith('/', 0)) {
        throw new Error('MENSAJES.GRALS.VALOR_INICIA_DIAGONAL');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public static validarCampoVacio(valor: any, objGenerico: ClsObjGenerico, campo: string) {
    try {
      if (valor?.length === 0 || this.esNulo(valor)) {
        throw new Error(objGenerico.getTranslationsAlertValidarCampos(objGenerico.getTranslationValidarColuma(campo)));
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public static async obtenerEncabezadoReporte(infPpto: AppPresupuestosService, objCatalogoPptosGrals: ClsObjCatalogoPresupuestosGenerales, objGenerico: ClsObjGenerico): Promise<ClsEncabezadoReporte> {
    const encabezadoReporte: ClsEncabezadoReporte = new ClsEncabezadoReporte();
    const objParamPpto: ClsObjParametrosPorPpto = new ClsObjParametrosPorPpto();
    let fecha = '';
    try {
      const ppto: ClsPresupuestos = await objCatalogoPptosGrals.obtenerDetallePresupuesto(infPpto.pptoSeleccionadoActivo.IdPresupuesto);
      const param: ClsParametro[] = await objGenerico.obtenerNParametros(infPpto.pptoSeleccionadoActivo.IdPresupuesto, EnumTipoParametro.Presupuesto, objParamPpto.getParametrosEncabezado());
      encabezadoReporte.Empresa = this.esNulo(ppto.Empresa.RazonSocialEmpresa) ? '' : ppto.Empresa.RazonSocialEmpresa;
      encabezadoReporte.Cliente = ppto.Cliente.NombreCliente;
      encabezadoReporte.Obra = ppto.NombrePresupuesto;
      encabezadoReporte.Lugar = ppto.Direccion;
      encabezadoReporte.Ciudad = ppto.Ciudad.DescripcionCiudad;
      encabezadoReporte.Estado = ppto.Ciudad.Estado.NombreEstado;
      encabezadoReporte.Logo = '';
      encabezadoReporte.Responsable = ppto.Responsable.NombreResponsable;
      encabezadoReporte.CargoResponsable = ppto.Responsable.CargoResponsable;
      encabezadoReporte.Iva = Number.isInteger(ppto.PorcentajeIVA) ? ppto.PorcentajeIVA / 100 : ppto.PorcentajeIVA;
      encabezadoReporte.TotalPresupuesto = ClsUtil.numberX(param.find(para => para.Parametro === EnumParaPpto.PPTOPRECIOTOTAL).Valor);
      fecha = param.find(para => para.Parametro === EnumParaPpto.LICFECHAINICIO).Valor;
      encabezadoReporte.FechaInicioLic = !ClsUtil.esNulo(fecha) ? new Date(fecha) : new Date();
      fecha = param.find(para => para.Parametro === EnumParaPpto.LICFECHAFINAL).Valor;
      encabezadoReporte.FechaFinalLic = !ClsUtil.esNulo(fecha) ? new Date(fecha) : new Date();
      encabezadoReporte.NumeroConcurso = param.find(para => para.Parametro === EnumParaPpto.LICNUMLICITACION).Valor;
      encabezadoReporte.DuracionConcurso = `${ClsUtil.obtenerNumDiferenciaFechaEntreFecha(encabezadoReporte.FechaInicioLic, encabezadoReporte.FechaFinalLic)} días naturales`;
      //  datos de la empresa
      infPpto.mapCamposGenerales.set('razonsocial', ppto.Empresa.Empresa);
      infPpto.mapCamposGenerales.set('domicilio', ppto.Empresa.DireccionEmpresa);
      infPpto.mapCamposGenerales.set('colonia', ppto.Empresa.Colonia);
      infPpto.mapCamposGenerales.set('ciudad', ppto.Empresa.Ciudad.DescripcionCiudad);
      infPpto.mapCamposGenerales.set('estado', ppto.Empresa.Ciudad.Estado.NombreEstado);
      infPpto.mapCamposGenerales.set('rfc', ppto.Empresa.RfcEmpresa);
      infPpto.mapCamposGenerales.set('telefono', ppto.Empresa.TelefonoEmpresa);
      infPpto.mapCamposGenerales.set('email', ppto.Empresa.MailEmpresa);
      infPpto.mapCamposGenerales.set('cmic', ppto.Empresa.CMICEmpresa);
      infPpto.mapCamposGenerales.set('infonavit', ppto.Empresa.InfonavitEmpresa);
      infPpto.mapCamposGenerales.set('imss', ppto.Empresa.IMSSEmpresa);
      infPpto.mapCamposGenerales.set('responsable', ppto.Empresa.Responsable.NombreResponsable);
      infPpto.mapCamposGenerales.set('cargo', ppto.Empresa.Responsable.CargoResponsable);
      //  datos del cliente
      infPpto.mapCamposGenerales.set('nombrecliente', ppto.Cliente.NombreCliente);
      infPpto.mapCamposGenerales.set('area', param.find(para => para.Parametro === EnumParaPpto.AREACLIENTE).Valor);
      infPpto.mapCamposGenerales.set('departamento', param.find(para => para.Parametro === EnumParaPpto.DEPARTAMENTOCLIENTE).Valor);
      infPpto.mapCamposGenerales.set('direccioncliente', ppto.Cliente.DireccionCliente);
      infPpto.mapCamposGenerales.set('coloniacliente', ppto.Cliente.ColoniaCliente);
      infPpto.mapCamposGenerales.set('codigopostalcliente', ppto.Cliente.CodigoPostalCliente);
      infPpto.mapCamposGenerales.set('ciudadcliente', ppto.Cliente.Ciudad.DescripcionCiudad);
      infPpto.mapCamposGenerales.set('telefonocliente', ppto.Cliente.TelefonoCliente);
      infPpto.mapCamposGenerales.set('emailcliente', ppto.Cliente.MailCliente);
      infPpto.mapCamposGenerales.set('contactocliente', ppto.ClienteContacto.NombreClienteContacto);
      //  datos del concurso
      infPpto.mapCamposGenerales.set('fechadeconcurso', ClsUtil.formatoFechaManualPipe(param.find(para => para.Parametro === EnumParaPpto.LICFECHALICITACION).Valor, 'dd/MM/yyyy'));
      infPpto.mapCamposGenerales.set('numerodeconcurso', param.find(para => para.Parametro === EnumParaPpto.LICNUMLICITACION).Valor);
      infPpto.mapCamposGenerales.set('direcciondeconcurso', param.find(para => para.Parametro === EnumParaPpto.LICLUGARCELEBRACION).Valor);
      //  datos de la obra
      infPpto.mapCamposGenerales.set('nombredelaobra', ppto.NombrePresupuesto);
      infPpto.mapCamposGenerales.set('direcciondelaobra', ppto.Direccion);
      infPpto.mapCamposGenerales.set('coloniadelaobra', ppto.Colonia);
      infPpto.mapCamposGenerales.set('ciudaddelaobra', ppto.Ciudad.DescripcionCiudad);
      infPpto.mapCamposGenerales.set('estadodelaobra', ppto.Ciudad.Estado.NombreEstado);
      infPpto.mapCamposGenerales.set('codigopostaldelaobra', ppto.CodPost);
      infPpto.mapCamposGenerales.set('telefonodelaobra', ppto.Telefono);
      infPpto.mapCamposGenerales.set('emaildelaobra', ppto.EMail);
      infPpto.mapCamposGenerales.set('responsabledelaobra', ppto.Responsable.NombreResponsable);
      infPpto.mapCamposGenerales.set('cargoresponsabledelaobra', ppto.Responsable.CargoResponsable);
      infPpto.mapCamposGenerales.set('fechainicio', encabezadoReporte.FechaInicioLic);
      infPpto.mapCamposGenerales.set('fechaterminacion', encabezadoReporte.FechaFinalLic);
      infPpto.mapCamposGenerales.set('totalpresupuestoprimeramoneda', ClsUtil.numberX(param.find(para => para.Parametro === EnumParaPpto.PPTOPRECIOTOTAL).Valor));
      infPpto.mapCamposGenerales.set('totalpresupuestosegundamoneda', ClsUtil.numberX(param.find(para => para.Parametro === EnumParaPpto.PPTOPRECIOTOTAL).Valor));
      infPpto.mapCamposGenerales.set('porcentajeivapresupuesto', ppto.PorcentajeIVA / 100);
      //  datos encabezados
      infPpto.mapCamposGenerales.set('plazocalculado', 0);
      infPpto.mapCamposGenerales.set('plazoreal', 0);
      infPpto.mapCamposGenerales.set('decimalesredondeo', infPpto.decimalredondearimporte);
      infPpto.mapCamposGenerales.set('primeramoneda', param.find(para => para.Parametro === EnumParaPpto.DESCRIPCIONMONEDA1).Valor);
      infPpto.mapCamposGenerales.set('segundamoneda', param.find(para => para.Parametro === EnumParaPpto.DESCRIPCIONMONEDA2).Valor);
      infPpto.mapCamposGenerales.set('remateprimeramoneda', param.find(para => para.Parametro === EnumParaPpto.MONEDA1).Valor);
      infPpto.mapCamposGenerales.set('rematesegundamoneda', param.find(para => para.Parametro === EnumParaPpto.MONEDA2).Valor);
      //  datos de la convocatoria
      infPpto.mapCamposGenerales.set('numconvocatoria', param.find(para => para.Parametro === EnumParaPpto.LICNUMCONVOCATORIA).Valor);
      infPpto.mapCamposGenerales.set('fechaconvocatoria', ClsUtil.formatoFechaManualPipe(param.find(para => para.Parametro === EnumParaPpto.LICFECHAPUBLICACION).Valor, 'dd/MM/yyyy'));
      infPpto.mapCamposGenerales.set('tipodelicitacion', ppto.TiposLicitacion.TipoLicitacion);
    } catch (e) {
      throw new Error(e.message);
    }
    return encabezadoReporte;
  }

  public static crearMapCountPartidaPorNivel(processedRecords: Map<any, ITreeGridRecord>): Map<number, number> {
    const countPorNivel: Map<number, number> = new Map<number, number>();
    processedRecords.forEach(value => {
      const nivel: number = value.level;
      const count = 1;
      if (countPorNivel.has(nivel)) {
        const countMap: number = countPorNivel.get(nivel);
        countPorNivel.set(nivel, countMap + count);
      } else {
        countPorNivel.set(nivel, count);
      }
    });
    return countPorNivel;
  }

  public static leftPad(numero: number, targetLength: number): string {
    let output = numero + '';
    while (output.length < targetLength) {
      output = '0' + output;
    }
    return output;
  }

  public static validarMinMaxInput(min: number, max: number, valor: number): number {
    if (valor < min) {
      return min;
    }
    if (valor > max) {
      return max;
    }
    return valor;
  }

  public static acumularImporteXTipo(tipoPorc: ClsDetalleMatrizInsumos[], data: ClsDetalleMatrizInsumos[], _DECIMALREDONDEARIMPORTE: number): Map<number, ClsImportePorTipo> {
    const mapImpoTipos: Map<number, ClsImportePorTipo> = new Map<number, ClsImportePorTipo>();
    data = data.filter(value => value.EsPorcentaje === 0);
    tipoPorc.forEach(tipo => {
      const importes: ClsImportePorTipo = new ClsImportePorTipo();
      const dataFiltrada: any[] = data.filter(value => value.TipoInsumo === tipo.EsPorcentaje);
      importes.CostoMoneda1 = 0;
      importes.CostoMoneda2 = 0;
      if (dataFiltrada.length > 0) {
        dataFiltrada.forEach(value => {
          importes.CostoMoneda1 = ClsUtil.redondearMoneda(importes.CostoMoneda1 + value.ImporteMoneda1, _DECIMALREDONDEARIMPORTE);
          importes.CostoMoneda2 = ClsUtil.redondearMoneda(importes.CostoMoneda2 + value.ImporteMoneda2, _DECIMALREDONDEARIMPORTE);
        });
        mapImpoTipos.set(tipo.EsPorcentaje, importes);
      } else {
        mapImpoTipos.set(tipo.EsPorcentaje, importes);
      }
    });
    return mapImpoTipos;
  }

  public static vistaPrevia(url: string, target = '_blank', features?: string) {
    if (this.cadenaX(url).length) {
      window.open(url, target, features);
    }
  }

  public static formatCopy(selectedData: any) {
    let dataStr = '';
    selectedData.forEach(x => {
      const values = Object.values(x);
      dataStr = dataStr + values.join('\t') + '\n';
    });
    return Object.keys(selectedData[0]).join('\t') + '\n' + dataStr;
  }

  public static obtenerNumDiferenciaFechaEntreFecha(fechaInicial: any, fechaFinal: any): number {
    const fecha1 = new Date(fechaInicial);
    const fecha2 = new Date(fechaFinal);
    const diferenciaTiempo = (fecha2.getTime() - fecha1.getTime()) + 1;
    return Math.ceil(diferenciaTiempo / (1000 * 60 * 60 * 24));
  }

  public static obtenerNumDiferenciaDiaEntreFecha(fechaComparar: any): number {
    const hoy = new Date(Date.now());
    const fecha = new Date(fechaComparar);
    const diferenciaTiempo = hoy.getTime() - fecha.getTime();
    return Math.ceil(diferenciaTiempo / (1000 * 60 * 60 * 24));
  }

  public static obtenerNumDiferenciaDiaEntreFecha2(fechaComparar: any): number {
    const hoy = new Date(Date.now());
    const fecha = new Date(fechaComparar);
    const diferenciaTiempo = (fecha.getTime() - hoy.getTime()) + 1;
    return Math.ceil(diferenciaTiempo / (1000 * 60 * 60 * 24));
  }

  public static convertBlobToFile(blob: Blob, nombre: string, lastModified: number = Date.now()): File {
    return new File([blob], nombre, {type: blob.type, lastModified: lastModified});
  }

  public static getFormattedData(grid: {
    columns: { hidden: boolean; field: string; header: string }[]
  }, filteredData: Record<string, any>[]): string {
    const colsVisible = grid.columns.filter((col) => !col.hidden).map(({field, header}) => ({field, header}));
    const fields = colsVisible.map(({field}) => field);
    const processedData: Record<string, any>[] = [];

    filteredData.forEach((item) => {
      const newItem = Object.keys(item)
        .sort((a, b) => fields.indexOf(a) - fields.indexOf(b))
        .reduce((acc: Record<string, any>, key) => {
          colsVisible.forEach((x) => {
            if (x.field === key) {
              if (key === 'DescripcionLarga' || key === 'Descripcion') {
                item[key] = item[key]?.replace(/[\t\n]/gm, '') || '';
              }
              // TODO: falta revisar si funciona con Datetime...
              if (item[key] instanceof Date) {
                // se copia en este formato, porque es el formato que recibe el grid
                acc[x.header] = ClsUtil.formatoFechaManualPipe(item[key], 'MM/dd/yyyy');
              } else {
                acc[x.header] = item[key];
              }
            }
          });
          return acc;
        }, {});
      processedData.push(newItem);
    });

    return this.formatCopy(processedData);
  }

  public static getExtensionArchivo(nombreArchivo: string): string {
    // extraer extension
    const extraer: RegExpExecArray = new RegExp(/(?:\.([^.]+))?$/).exec(nombreArchivo);
    // si es null indica que no tiene extension
    return this.esNulo(extraer) ? '' : extraer[0];
  }

  public static reemplazarInfoArchivosStorage(listaArchivos: ClsListaArchivos[], tipoDocumento: string, prefix: string): ClsListaArchivos[] {
    let extension: string;
    listaArchivos.forEach(value => {
      extension = this.getExtensionArchivo(value.NombreArchivo);
      value.Neodata = true;
      value.TipoDocumento = tipoDocumento;
      value.Documento = value.NombreArchivo.replace(extension, '').replace(prefix, '');
      value.Extension = extension;
    });

    return listaArchivos;
  }

  /**
   * Si en el listado ya hay un archivo de esa moneda y el nombre en storage cambiaría, devuelve el objeto para EliminaListaArchivosStorage.
   * Misma lógica que guardarArchivoStorage en Fasar/Sobrecosto (evita huérfanos al renombrar).
   */
  public static recolectarBorradoSiRenombreMoneda(idppto: bigint, nomBucket: string, lista: ClsListaArchivos[], nomArchivoNuevo: string, prefixMoneda: string, nomPrefixCarpeta: string): ClsContenidoBucketStorage[] {
    const hay = lista.find(value => value.NombreArchivo.includes(prefixMoneda));
    if (this.esNulo(hay)) {
      return [];
    }
    const nomArchivo2 = `${nomPrefixCarpeta}/${hay.Documento.replace(prefixMoneda, '')}${prefixMoneda}${hay.Extension}`;
    if (nomArchivoNuevo === nomArchivo2) {
      return [];
    }
    return [{
      NombreBucket: nomBucket,
      NombreArchivo: `${idppto.toString()}/${nomArchivo2}`
    }];
  }

  /** Añade un ítem a la lista de subida masiva si el libro cambió respecto al contenido guardado en memoria. */
  public static agregarItemSubidaLibroSiCambio(destino: ClsDatosBucketSube[], libro: ClsListaArchivos | undefined, contenidoGuardado: string | undefined, nomBucket: string, rutaRelativaPresupuesto: string): void {
    if (this.esNulo(libro) || libro.ContenidoBase64 === contenidoGuardado) {
      return;
    }
    destino.push({
      NombreBucket: nomBucket,
      NombreArchivo: rutaRelativaPresupuesto,
      FormatoMIME: libro.TipoArchivo,
      ContenidoArchivo: libro.ContenidoBase64
    });
  }

  public static async inicializarDatosSubirArchivoLocal(file: File, prefix: string): Promise<ClsListaArchivos> {
    const doc: ClsListaArchivos = new ClsListaArchivos();
    let base64: string;
    try {
      doc.ContenidoArchivoFile = file;
      // docPieInd.Workbook = await ExcelUtility.load(file);
      doc.Extension = this.getExtensionArchivo(file.name);
      doc.Documento = file.name.replace(prefix, '').replace(doc.Extension, '');
      doc.TipoArchivo = file.type;
      base64 = await this.convertBlobOrFileToBase64String(file).then((resp: string) => resp);
      if (this.esNulo(base64)) {
        throw new Error('MENSAJES.ERROR.HOJA_FORMATO_NO_CORRECTO');
      }
      doc.ContenidoBase64 = base64.split('base64,')[1];
      return doc;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public static async inicializarListaDeDescargaArchivos(idppto: bigint, archivos: ClsArchivosEntrada, objGenerico: ClsObjGenerico): Promise<Map<string, ClsListaArchivos>> {
    let arrayFiles: ClsContenidoBucketStorage[] = [];

    const pushFile = (tipo: string, nombre?: string, prefix?: string) => {
      if (this.esNulo(nombre)) return;

      arrayFiles.push({
        NombreBucket: objGenerico.gNomBocketPpto,
        NombreArchivo: `${idppto.toString()}/${prefix}/${nombre}`,
        NombreDocumento: nombre,
        Tipo: tipo
      });
    };
    // 🔥 armado limpio
    pushFile(EnumLibros.CH, archivos.CH, objGenerico.gNomPrefixPptoCH);
    pushFile(EnumLibros.FASAR, archivos.FASAR, objGenerico.gNomPrefixPptoFASAR);
    pushFile(EnumLibros.SC, archivos.SC, objGenerico.gNomPrefixPptoSC);
    pushFile(EnumLibros.PI, archivos.PI, objGenerico.gNomPrefixPptoPI);

    const mapResp = new Map<string, ClsListaArchivos>();
    if (arrayFiles.length === 0) {
      return mapResp;
    }
    try {
      const respFiles: ClsRespuestaDescargaArchivosStorage[] = await objGenerico.descargarListaArchivoStorage(arrayFiles);
      const now = Date.now();
      for (let i = 0, len = respFiles.length; i < len; i++) {
        const value = respFiles[i];
        const fileReq = arrayFiles[i];
        let documento: ClsListaArchivos = {} as ClsListaArchivos;

        // validar si hay algun error en la descarga
        const error = value?.Errores?.ErrorDescripcion?.trim();
        if (error) {
          const mensajeVal = objGenerico.getTranslationsSubject('MENSAJES.ERROR.NO_EXISTE_FILE');
          if (error.includes(mensajeVal) || error.includes("storage: object doesn't exist")) {
            // 🔥 CASO ESPECIAL CH
            if (fileReq.Tipo === EnumLibros.CH) {
              documento = await objGenerico.mObjCH.subirDocumentoDefaultCH(idppto);
              mapResp.set(EnumLibros.CH, documento);
            } else {
              mapResp.set(fileReq.Tipo, documento);
            }
            continue;
          }
          // 🚨 error real
          throw new Error(error);
        }

        const nombreDocumento = fileReq.NombreDocumento;
        const extension = ClsUtil.getExtensionArchivo(nombreDocumento);

        documento.ContenidoBase64 = value.ContenidoArchivo || '';

        // 🔥 VALIDACIÓN CRÍTICA CH
        if (fileReq.Tipo === EnumLibros.CH && !documento.ContenidoBase64) {
          documento = await objGenerico.mObjCH.subirDocumentoDefaultCH(idppto);
          mapResp.set(EnumLibros.CH, documento);
          continue;
        }

        documento.TipoArchivo =
          extension === 'xlsx' ? EnumMIMETypes.XLSX :
            extension === 'xls'  ? EnumMIMETypes.XLS  :
              EnumMIMETypes.OTRO;

        documento.Documento = nombreDocumento.replace(objGenerico.gPrefixMoneda1, '').replace(extension, '');
        documento.Extension = extension;
        // convert base 64 a blob
        const blobFile = this.convertBase64StringToBlob(documento.ContenidoBase64, documento.TipoArchivo);
        // convertir blob a File
        documento.ContenidoArchivoFile = ClsUtil.convertBlobToFile(blobFile, documento.Documento + extension, now);
        // docPieInd.Workbook = await ExcelUtility.load(docPieInd.ContenidoArchivoFile);

        mapResp.set(fileReq.Tipo, documento);
      }

      return mapResp;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public static async inicializarDescargaArchivo(nomBocketPpto: string, rutaNomArchivo: string, nomArchivo: string, prefixMoneda: string, objGenerico: ClsObjGenerico): Promise<ClsListaArchivos> {
    const documento: ClsListaArchivos = new ClsListaArchivos();
    try {
      // descargar archivo storage
      const respArchivo: ClsRespuestaDescargaArchivosStorage = await objGenerico.descargarArchivoStorage(nomBocketPpto, rutaNomArchivo);
      documento.Extension = ClsUtil.getExtensionArchivo(nomArchivo);
      // convertir base 64 a blob
      documento.ContenidoBase64 = respArchivo.ContenidoArchivo;
      if (documento.Extension === '.xlsx') {
        documento.TipoArchivo = EnumMIMETypes.XLSX;
      } else if (documento.Extension === '.xls') {
        documento.TipoArchivo = EnumMIMETypes.XLS;
      } else {
        documento.TipoArchivo = EnumMIMETypes.OTRO;
      }
      const blobFile = this.convertBase64StringToBlob(documento.ContenidoBase64, documento.TipoArchivo);
      documento.Documento = nomArchivo.replace(prefixMoneda, '').replace(documento.Extension, '');
      // convertir blob a File
      documento.ContenidoArchivoFile = ClsUtil.convertBlobToFile(blobFile, documento.Documento + documento.Extension);
      // docPieInd.Workbook = await ExcelUtility.load(docPieInd.ContenidoArchivoFile);
      return documento;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public static async descargarArchivoCargarVnt(idPpto: string, prefixMoneda: string, nombreLibro: string, nomBocketLibro: string, nomPrefixNeodata: string, nomPrefixPptoSubRuta: string, objGenerico: ClsObjGenerico): Promise<ClsListaArchivos> {
    try {
      const ruta: string = ClsUtil.esNulo(idPpto) ? `${nomPrefixNeodata}/${nombreLibro}` : `${idPpto}/${nomPrefixPptoSubRuta}/${nombreLibro}`;
      return await ClsUtil.inicializarDescargaArchivo(nomBocketLibro, ruta, nombreLibro, prefixMoneda, objGenerico);
    } catch (e) {
      const mensajeVal = objGenerico.getTranslationsSubject('MENSAJES.ERROR.NO_EXISTE_FILE');
      if (e.message.toString().includes(mensajeVal) || e.message.toString().includes("storage: object doesn't exist")) {
        return undefined;
      } else {
        throw new Error(e.message);
      }
    }
  }

  /**
   * Metodo para borrar archivo en storage
   * @param idPpto
   * @param nomArchivo
   * @param nomBocketPpto
   * @param nomPrefixPptoSubFolder
   * @param objGenerico
   * @return OK si se borro correctamente o undefined si no existe el archivo y si omite el error
   * @return throw new Error(e.message) en caso de mandar mensaje distinto a "storage: object doesn't exist"
   */
  public static async borrarArchivoStorage(idPpto: string, nomArchivo: string, nomBocketPpto: string, nomPrefixPptoSubFolder: string, objGenerico: ClsObjGenerico) {
    try {
      await objGenerico.borrarArchivosStorage(nomBocketPpto, `${idPpto}/${nomPrefixPptoSubFolder}/${nomArchivo}`);
      return 'OK';
    } catch (e) {
      const mensajeVal = objGenerico.getTranslationsSubject('MENSAJES.ERROR.NO_EXISTE_FILE');
      if (e.message.toString().includes(mensajeVal) || e.message.toString().includes("storage: object doesn't exist")) {
        return undefined;
      } else {
        throw new Error(e.message);
      }
    }
  }

  public static ubicaHoja(libro: Workbook, nomHoja: string): number {
    try {
      return libro.sheets(nomHoja).sheetIndex;
    } catch (e) {
      return -1;
    }
  }

  public static vaciaValorHoja(hoja: Worksheet, nomParametro: string, valor: any) {
    const celda: WorksheetCell = hoja.getCell(nomParametro);
    if (!this.esNulo(celda)) {
      celda.value = valor;
    }
  }

  public static obtieneValorDecimalHoja(hoja: Worksheet, nomParametro: string): number {
    const celda: WorksheetCell = hoja.getCell(nomParametro);
    return this.esNulo(celda) ? 0 : celda.value;
  }

  /**
   * Obtiene fila y columna (0-based) de una celda por nombre o dirección.
   * Equivalente VB: ObtieneFilaColumna(Hoja, NombreCelda, Fila, Columna) → Fila = Hoja.Cells(NombreCelda).Row, Columna = Hoja.Cells(NombreCelda).Column.
   * Usa Worksheet.getCell + WorksheetCell.rowIndex / columnIndex de igniteui-angular-excel.
   */
  public static obtieneFilaColumna(hoja: Worksheet, nombreCelda: string): { fila: number; columna: number } {
    const out = { fila: -1, columna: -1 };
    try {
      const celda: WorksheetCell = hoja.getCell(nombreCelda);
      if (this.esNulo(celda)) return out;
      out.fila = celda.rowIndex;
      out.columna = celda.columnIndex;
    } catch {
      // mantener -1, -1
    }
    return out;
  }

  /**
   * Escribe un valor en la hoja por fila y columna (0-based).
   * Equivalente VB: VaciaValorHoja(ByRef Hoja, Fila, Columna, valor) — Hoja.Cells(Fila, Columna).Value = valor;
   * si el valor es fecha, aplica formato "dd/MM/yyyy".
   */
  public static vaciaValorHojaPorFilaColumna(hoja: Worksheet, fila: number, columna: number, valor: unknown): void {
    if (fila < 0 || columna < 0) return;
    try {
      const celda: WorksheetCell = hoja.rows(fila).cells(columna);
      celda.value = valor;
      // const fecha = valor instanceof Date ? valor : new Date(valor as string | number);
      // if (!Number.isNaN(fecha.getTime())) {
      //   celda.cellFormat.formatString = 'dd/MM/yyyy';
      //   celda.value = valor;
      // }
    } catch {
      // ignorar errores de escritura
    }
  }

  public static obtenerPartidaPreviaNivelSeleccionado(indexR: any, grid: any, partidaSelected: any) {
    let partidaPrevLevel; // undefined;
    if (!this.esNulo(partidaSelected)) {
      for (let i = indexR + 1; i < [...grid.processedRecords].reverse().length; i++) {
        if ([...grid.processedRecords].reverse()[i][1].level === partidaSelected[1].level && [...grid.processedRecords].reverse()[i][1].data.IdPartidaPadre === partidaSelected[1].data.IdPartidaPadre) {
          partidaPrevLevel = [...grid.processedRecords].reverse()[i]; // [1].data.DescripcionPartida;
          break;
        }
      }
    }
    return partidaPrevLevel;
  }

  public static obtenerPartidaSiguienteNivelSeleccionado(index: any, grid: any, partidaSelected: any) {
    try {
      let partidaPrevLevel; // undefined;
      if (!this.esNulo(partidaSelected)) {
        for (let i = index + 1; i < [...grid.processedRecords].length; i++) {
          if ([...grid.processedRecords][i][1].level === partidaSelected[1].level && [...grid.processedRecords][i][1].data.IdPartidaPadre === partidaSelected[1].data.IdPartidaPadre) {
            partidaPrevLevel = [...grid.processedRecords][i]; // [1].data.DescripcionPartida;
            break;
          }
        }
      }
      return partidaPrevLevel;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public static regenerarRenglon(flatData: any[]): any[] {
    try {
      let renglonRoot = 0;
      flatData.forEach(x => {
        if (x.IdPartidaPadre === 0n) {
          renglonRoot = renglonRoot + 10;
          x.Renglon = renglonRoot;
        }
        const children = flatData.filter(y => y.IdPartidaPadre === x.IdPresupuestoPartida);
        if (children.length !== 0) {
          let renglonChild = 0;
          children.forEach(y => {
            renglonChild = renglonChild + 10;
            y.Renglon = renglonChild;
          });
        }
      });
      return flatData;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public static formatoDecimales(decimal: string): string {
    return '1.' + decimal + '-' + decimal;
  }

  public static cambiarFormatosGridsDecimales(infPpto: AppPresupuestosService) {
    const dmSecundario = ClsUtil.getDMSecundarioActivoMaestro(infPpto);
    if (!ClsUtil.esNulo(dmSecundario)) {
      dmSecundario.Ppto?.partidaComponent.cambiarDecimal();
      dmSecundario.Ppto?.partidaComponent.tituloPrecioCostoPptoPartida(dmSecundario?.Ppto.partidaComponent.partidaSeleccionado);
      dmSecundario.Ppto?.conceptosComponent.cambiarDecimal();
      dmSecundario.Ppto?.ExpInsumoAcoplado.cambiarDecimal();
      dmSecundario.MActivo?.cambiarDecimal();
      dmSecundario.MActivo?.ExpInsumoAcoplado.cambiarDecimal();
      dmSecundario.PptoCompleto?.cambiarDecimal();
      dmSecundario.ExpInsumo?.ExpInsumoAcoplado.cambiarDecimal();
      dmSecundario.MAT?.cambiarDecimal();
      dmSecundario.MO?.cambiarDecimal();
      dmSecundario.EQ?.cambiarDecimal();
    }
  }

  public static esCostoHorario(objExpInsumos: ClsObjExplosionDeInsumos, codigo: string): boolean {
    const existe = objExpInsumos.buscarCodigoEnExpIns(codigo);
    return !ClsUtil.esNulo(existe) ? existe.EsCostoHorario : false;
  }

  /**
   * @param documentSize - Tamaño del componente
   * @param clickPosition - Posicion del click
   * @param isWidth - verifica que lado es, width o height
   * @param lengthMenu - número de opciones en el menu contextual
   * @description Recalcula la posicion de aparicion del menu contextual para que no se vea incompleto
   */
  public static calcPosition(documentSize: number, clickPosition: number, isWidth: boolean, lengthMenu?: number): number {
    const sizeMenu = isWidth ? 285 : (lengthMenu * 37); // 285 ancho, 37 px x item hight
    return documentSize - clickPosition < sizeMenu ? clickPosition - (sizeMenu) < 0 ? 0 : (clickPosition - sizeMenu) : (clickPosition + 2);
  }

  // public static validarDataMax(valor: any, maxLength, objGenerico: ClsObjGenerico, header: string) {
  //   try {
  //     if (valor.length > maxLength) {
  //       throw new Error(objGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CAMPO_MAXIMO').replace('{0}', header).replace('{1}', maxLength));
  //     }
  //   } catch (e) {
  //     throw new Error(e.message);
  //   }
  // }

  public static toSubstring(valor: string, maxLength: number) {
    try {
      return this.cadenaX(valor).substring(0, maxLength);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public static obtenerFormasOImagenesHojaExcel(hoja: Worksheet, startsWith: string[]): any[] {
    const respArrayImg: any[] = [];
    const formas: WorksheetShapeCollection = hoja.shapes();
    for (let i = 0; i < formas.count; i++) {
      const img: WorksheetShape = formas.item(i);
      const existe: number = startsWith.findIndex(texto => {
        if (!this.esNulo(img._b8)) {
          img._b8.toUpperCase().startsWith(texto.toUpperCase());
        }
      });
      if (existe !== -1) {
        const arrayImg: number[] = (img as WorksheetImage).image.b;
        respArrayImg.push(arrayImg);
      }
    }
    return respArrayImg;
  }

  /**
   * validar extensión de los archivos
   * @param nombre nombre con extensión
   * @param objGenerico objecto para obtener el mensaje traducido para mandar mensje en caso de no pasar la validación
   * @param tiposPermitidos arreglo de extensiones a validar ejemplo: ['zip'], ['xlsx', 'xls'], etc...
   */
  public static validarExtensionesArchivo(nombre: string, objGenerico: ClsObjGenerico, tiposPermitidos: string[]) {
    try {
      // Construir una expresión regular a partir de los tipos permitidos
      const regex = new RegExp(`\\.(${tiposPermitidos.join('|')})$`, 'i');
      // Validar el formato del archivo
      if (!regex.test(nombre)) {
        const mensaje: string = objGenerico.getTranslationsMensajes('MENSAJES.GRALS.ARCHIVO_VALIDO_EXTENSION');
        const tiposTexto = tiposPermitidos.join(', ').toUpperCase();
        throw new Error(mensaje.replace('{0}', nombre).replace('{1}', tiposTexto));
      }
      return true;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  /**
   * Metodo para validar numeros negativos
   * @param valor
   */
  public static validaraMayorCero(valor: number): number {
    return (valor > 0) ? valor : 0;
  }

  public static CFParticipaEnCostoHorario(idCF: bigint, infPpto: AppPresupuestosService): boolean {
    const costoHorarios: ClsCostoHorarios[] = ClsUtil.getPptoCompletoActivoMaestroJSON(infPpto).CostoHorarios;
    const existe: number = costoHorarios.findIndex(value => value.IdCatalogoCF === idCF);
    return existe !== -1;

  }

  public static participaEnCostoHorario(idCat: bigint, infPpto: AppPresupuestosService): boolean {
    const costoHorarios: ClsCostoHorarios[] = ClsUtil.getPptoCompletoActivoMaestroJSON(infPpto).CostoHorarios;
    const existe: number = costoHorarios.findIndex(value => value.IdCatalogoCostoHorario === idCat);
    return existe !== -1;

  }

  /**
   * Meteodo que convierte precio a letra en ES o EN
   * @param lnumero valor a convertir
   * @param esEspaniol se valida contra el valor del Idioma que se este ocupando en el sistema
   * @param moneda se toma del detalle del presupuesto en el tab de otros
   * @param remate se toma del detalle del presupuesto en el tab de otros
   * @param redondear a cuantos decimales se quiere mostrar
   * @param encierraEnParentesis si desea con parentesis o no
   */
  public static precioConLetra(lnumero: number, esEspaniol: boolean, moneda: string, remate: string, redondear = 2, encierraEnParentesis = true): string {
    let numPesos: number;
    let numMiles: number;
    let numMillon: number;
    let numMilMillon: number;
    let numeroAuxiliar: number;
    let numeroOriginal: number;
    let numCentavos: number;

    let texcon: string; // strConLet;
    // long numero, redondea;
    let strNumori = '';
    const valNum6 = '000000';
    const valNum7 = '0000000';
    const valNum8 = '00000000';
    const valNum9 = '000000000';
    const valNum10 = '0000000000';
    const valNum11 = '00000000000';
    texcon = '';

    numeroOriginal = lnumero;
    if (encierraEnParentesis) {
      texcon = '(*';
    }
    numMilMillon = ~~(lnumero / 1000000000); // numMilMillon = (long) (lnumero / 1000000000);
    numeroAuxiliar = numMilMillon * 1000000000;
    // lnumero -= numeroAuxiliar;
    lnumero = this.redondear(lnumero - numeroAuxiliar, 2);

    // String tmp = String.format('%f', lnumero);

    if (numMilMillon > 0) {
      if (esEspaniol) {
        texcon += this.conmil(numMilMillon, esEspaniol) + ' MIL ';
      } else {
        texcon += this.conmil(numMilMillon, esEspaniol) + ' THOUSAND ';
      }
    }

    numMillon = ~~(lnumero / 1000000); // (long) (lnumero / 1000000);
    numeroAuxiliar = numMillon * 1000000;
    // lnumero -= numeroAuxiliar;
    lnumero = this.redondear(lnumero - numeroAuxiliar, 2);
    if (numMillon > 0) {
      texcon += this.conmil(numMillon, esEspaniol);
    }

    if (numeroOriginal >= 2000000) {
      // NumberFormat f = NumberFormat.getFormat('#.0#');

      strNumori = numeroOriginal.toString(); // f.format(numeroOriginal);

      if (numMilMillon < 10 && numMilMillon > 0) {
        strNumori = strNumori.substring(1, 10);
      } else if (numMilMillon < 100 && numMilMillon > 0) {
        strNumori = strNumori.substring(1, 11);
      } else if (numMilMillon < 1000 && numMilMillon > 0) {
        strNumori = strNumori.substring(1, 12);
      } else if (numMillon < 10) {
        strNumori = strNumori.substring(1, 7);
      } else if (numMillon < 100) {
        strNumori = strNumori.substring(1, 8);
      } else if (numMillon < 1000) {
        strNumori = strNumori.substring(1, 9);
      } else if (numMilMillon < 10) {
        strNumori = strNumori.substring(1, 10);
      } else if (numMilMillon < 100) {
        strNumori = strNumori.substring(1, 11);
      } else if (numMilMillon < 1000) {
        strNumori = strNumori.substring(1, 12);
      }

      if (esEspaniol) {
        if (strNumori === valNum6 || strNumori === valNum7 || strNumori === valNum8 || strNumori === valNum9 || strNumori === valNum10 || strNumori === valNum11) {
          texcon += ' MILLONES DE ';
        } else {
          texcon += ' MILLONES ';
        }

      } else {
        if (strNumori === valNum7 || strNumori === valNum8 || strNumori === valNum9 || strNumori === valNum10 || strNumori === valNum11) {
          texcon += ' MILLIONS OF ';
        } else {
          texcon += ' MILLIONS ';
        }
      }
    } else if (numeroOriginal >= 1000000) {
      if (esEspaniol) {
        if (numeroOriginal.toString().substring(1, 7) === '000000') {
          texcon += ' MILLON DE ';
        } else {
          texcon += ' MILLON ';
        }
      } else {
        if (numeroOriginal.toString().substring(1, 7) === '000000') {
          texcon += ' MILLION OF ';
        } else {
          texcon += ' MILLION ';
        }
      }

    }

    numMiles = ~~(lnumero / 1000); // (long)(lnumero / 1000);
    numeroAuxiliar = numMiles * 1000;

    lnumero = this.redondear(lnumero - numeroAuxiliar, 2);

    if (numMiles > 0) {
      if (esEspaniol) {
        texcon += this.conmil(numMiles, esEspaniol) + ' MIL ';
      } else {
        texcon += this.conmil(numMiles, esEspaniol) + ' THOUSAND ';
      }
    }

    numPesos = Math.trunc(lnumero);
    if (numPesos > 0) {
      texcon += this.conmil(numPesos, esEspaniol);
    }

    texcon += moneda;
    numCentavos = lnumero - numPesos;
    numCentavos = this.redondear(numCentavos, 2);
    numCentavos = this.redondear(numCentavos * 100, 2);
    // NumberFormat
    // number = NumberFormat.getFormat('#,##0.00;-#,##0.00');
    // texcon += ' ' + number.format(ClsUtil.Redondear((numCentavos * 100), 0)) + '/100 ' + remate;

    texcon += ' ' + this.formatoMonedaPipeSinSimbolo$ConDecimal(numCentavos, `${redondear.toString()}.0-0`) + '/100 ' + remate;

    if (encierraEnParentesis) {
      texcon += ' *)';
    }
    return texcon;

  }

  private static conmil(mil: number, esEspaniol: boolean): string {

    let tex: string;
    let cen: number;
    let dec: number;
    let uni: number;

    // el simbolo + es igual que hacer parseInt
    if (mil.toString().length === 3) {
      cen = +mil.toString().substring(0, 1);
      dec = +mil.toString().substring(1, 2);
      uni = +mil.toString().substring(2, 3);
    } else if (mil.toString().length === 2) {
      cen = 0;
      dec = +mil.toString().substring(0, 1);
      uni = +mil.toString().substring(1, 2);
    } else {
      cen = 0;
      dec = 0;
      uni = +mil.toString().substring(0, 1);
    }
    tex = '';
    if (cen !== 0) {
      switch (cen) {
        case 1:
          if (esEspaniol) {
            tex += ' CIEN';
            if (dec > 0 || uni > 0) {
              tex += 'TO';
            } else {
              tex += ' ';
            }
          } else {
            tex += ' ONE ';
          }
          break;
        case 2:
          tex += esEspaniol ? ' DOSCIENTOS ' : ' TWO ';
          break;
        case 3:
          tex += esEspaniol ? ' TRESCIENTOS ' : ' THREE ';
          break;
        case 4:
          tex += esEspaniol ? ' CUATROCIENTOS ' : ' FOUR ';
          break;
        case 5:
          tex += esEspaniol ? ' QUINIENTOS ' : ' FIVE ';
          break;
        case 6:
          tex += esEspaniol ? ' SEISCIENTOS ' : ' SIX ';
          break;
        case 7:
          tex += esEspaniol ? ' SETECIENTOS ' : ' SEVEN ';
          break;
        case 8:
          tex += esEspaniol ? ' OCHOCIENTOS ' : ' EIGHT ';
          break;
        case 9:
          tex += esEspaniol ? ' NOVECIENTOS ' : ' NINE ';
          break;
      }// del switch
      //
      if (!esEspaniol && cen !== 0) {
        tex += ' HUNDRED ';
      }
    }
    // decenas
    // Si es español if(dec>2). Si es Ingles if(dec>1)
    const cuantasDecenasValidar: number = esEspaniol ? 2 : 1;

    if (dec > cuantasDecenasValidar) {
      switch (dec) {
        case 2:
          tex += esEspaniol ? ' VEINTE ' : ' TWENTY ';
          break;
        case 3:
          tex += esEspaniol ? ' TREINTA ' : ' THIRTY ';
          break;
        case 4:
          tex += esEspaniol ? ' CUARENTA ' : ' FORTY ';
          break;
        case 5:
          tex += esEspaniol ? ' CINCUENTA ' : ' FIFTY ';
          break;
        case 6:
          tex += esEspaniol ? ' SESENTA ' : ' SIXTY ';
          break;
        case 7:
          tex += esEspaniol ? ' SETENTA ' : ' SEVENTY ';
          break;
        case 8:
          tex += esEspaniol ? ' OCHENTA ' : ' EIGHTY ';
          break;
        case 9:
          tex += esEspaniol ? ' NOVENTA ' : ' NINETY ';
          break;
      }
      if (esEspaniol && uni > 0) {
        tex += ' Y ';
      }
    }
    // Unidades
    let condicionUnidades: boolean;
    condicionUnidades = uni > 0 && dec !== 1;
    //
    if (esEspaniol) {
      condicionUnidades = uni > 0 && dec !== 2 && dec !== 1;
    }
    //
    if (condicionUnidades) {
      switch (uni) {
        case 1:
          tex += esEspaniol ? ' UN ' : ' ONE ';
          break;
        case 2:
          tex += esEspaniol ? ' DOS ' : ' TWO ';
          break;
        case 3:
          tex += esEspaniol ? ' TRES ' : ' THREE ';
          break;
        case 4:
          tex += esEspaniol ? ' CUATRO ' : ' FOUR ';
          break;
        case 5:
          tex += esEspaniol ? ' CINCO ' : ' FIVE ';
          break;
        case 6:
          tex += esEspaniol ? ' SEIS ' : ' SIX ';
          break;
        case 7:
          tex += esEspaniol ? ' SIETE ' : ' SEVEN ';
          break;
        case 8:
          tex += esEspaniol ? ' OCHO ' : ' EIGHT ';
          break;
        case 9:
          tex += esEspaniol ? ' NUEVE ' : ' NINE ';
          break;

      }
    }
    // Decenas especiales
    if (dec === 1) {
      switch (uni) {
        case 0:
          tex += esEspaniol ? ' DIEZ ' : ' TEN ';
          break;
        case 1:
          tex += esEspaniol ? ' ONCE ' : ' ELEVEN ';
          break;
        case 2:
          tex += esEspaniol ? ' DOCE ' : ' TWELVE ';
          break;
        case 3:
          tex += esEspaniol ? ' TRECE ' : ' THIRTEEN ';
          break;
        case 4:
          tex += esEspaniol ? ' CATORCE ' : ' FOURTEEN ';
          break;
        case 5:
          tex += esEspaniol ? ' QUINCE ' : ' FIFTEEN ';
          break;
        case 6:
          tex += esEspaniol ? ' DIECISEIS ' : ' SIXTEEN ';
          break;
        case 7:
          tex += esEspaniol ? ' DIECISIETE ' : ' SEVENTEEN ';
          break;
        case 8:
          tex += esEspaniol ? ' DIECIOCHO ' : ' EIGHTEEN ';
          break;
        case 9:
          tex += esEspaniol ? ' DIECINUEVE ' : ' NINETEEN ';
          break;

      }
    }
    if (esEspaniol && dec === 2) {
      switch (uni) {
        case 0:
          tex += ' VEINTE ';
          break;
        case 1:
          tex += ' VEINTIUN ';
          break;
        case 2:
          tex += ' VEINTIDOS ';
          break;
        case 3:
          tex += ' VEINTITRES ';
          break;
        case 4:
          tex += ' VEINTICUATRO ';
          break;
        case 5:
          tex += ' VEINTICINCO ';
          break;
        case 6:
          tex += ' VEINTISEIS ';
          break;
        case 7:
          tex += ' VEINTISIETE ';
          break;
        case 8:
          tex += ' VEINTIOCHO ';
          break;
        case 9:
          tex += ' VEINTINUEVE ';
          break;
      }
    }

    return tex;
  }

  public static checkIfDividedBy100(valor: number): boolean {
    return valor * 100 === Math.round(valor * 100);
  }

  // public static encriptarPeticion(datosEncriptar: string, llave: string): string {
  //   let datosSplit: any;
  //   let resultado: any = '';
  //   try {
  //     this.encrypt.setPublicKey(llave);
  //     datosEncriptar = this.codificar(datosEncriptar);
  //     if (datosEncriptar.length > 117) {
  //       datosSplit = this.getChunksFromString(datosEncriptar, 117);
  //       datosSplit.forEach(value => {
  //         if (resultado.length > 0) {
  //           resultado += '.';
  //         }
  //         const rEncry: any = this.encrypt.encrypt(value);
  //         if (rEncry instanceof Boolean) {
  //           throw new Error('MENSAJES.ALERT.ENCRIPTAR_PETICION');
  //         }
  //         resultado += rEncry;
  //       });
  //     } else {
  //       const rEncry: any = this.encrypt.encrypt(datosEncriptar);
  //       if (rEncry instanceof Boolean) {
  //         throw new Error('MENSAJES.ALERT.ENCRIPTAR_PETICION');
  //       }
  //       resultado = rEncry;
  //     }
  //     resultado = this.codificar(resultado);
  //     return resultado;
  //   } catch (e) {
  //     throw new Error(e.message);
  //   }
  // }

  // public static getChunksFromString(str: string, chunkSize: number) {
  //   const regexChunk = new RegExp(`.{1,${chunkSize}}`, 'g');
  //   return str.match(regexChunk);
  // }

  public static detectarMimeType(b64: any) {
    const signatures = {
      iVBORw0KGgo: 'image/png',
      '/9j/': 'image/jpg'
    };
    for (const s in signatures) {
      if (b64.indexOf(s) === 0) {
        return signatures[s];
      }
    }
  }

  /**
   * Retorna los elementos duplicados de un array de objetos
   * @param arr - array de objetos
   * @param header - propiedad contra la que valida los elementos duplicados
   */
  public static findDuplicates(arr: any[], header: string) {
    let duplicates = [];
    for (let i = 0; i < arr.length; i++) {
      for (let j = 0; j < arr.length; j++) {
        if (i !== j) {
          if (arr[i][header] === arr[j][header]) {
            duplicates.push(arr[i][header]);
          }
        }
      }
    }
    duplicates = duplicates.filter((item, index) => duplicates.indexOf(item) === index);
    return duplicates;
  }

  public static numberFormat(valor: any, replaceValue = ''): number {
    if (ClsUtil.esNulo(valor)) {
      return 0;
    }
    // valor = Number(valor.toString().replace(',', '.'));
    valor = Number(valor.toString().replace(/[^0-9.-]+/g, replaceValue));
    return valor;
  }

  public static toNumber(valor: any): number {
    if (ClsUtil.esNulo(valor)) {
      return 0;
    }
    valor = Number(valor.toString().replace(',', '.'));
    return valor;
  }

  public static currencyToNumberFormat(valor: string): number {
    let num: number;
    if (ClsUtil.esNulo(valor)) {
      return 0;
    }
    const cleanedStr = valor.replace(/[^\d.,]/g, ''); // Quita los caracteres no numericos excepto la coma y punto
    const comaCount = (cleanedStr.match(/,/g) || []).length;
    const puntoCount = (cleanedStr.match(/\./g) || []).length;

    if (comaCount === 1 && puntoCount === 1) {
      // verificar las posiciones de la coma y el punto para determinar el tipo de moneda
      const charArray = [...cleanedStr];
      const comaIndex = charArray.indexOf(',');
      const puntoIndex = charArray.indexOf('.');
      if (puntoIndex < comaIndex) { // euro
        num = Number(cleanedStr.replace('.', '').replace(',', '.'));
      } else { // dollar mxn
        num = Number(cleanedStr.replace(',', ''));
      }
    } else {
      if (comaCount === 0 && puntoCount === 0) {
        num = Number(cleanedStr);
      }

      if (comaCount > puntoCount) {
        if (puntoCount !== 0) { // dollar
          num = Number(cleanedStr.replace(/,/g, ''));
        } else { // euro
          num = Number(cleanedStr.replace(/\./g, '').replace(',', '.'));
        }
      } else {
        if (comaCount !== 0) { // euro
          num = Number(cleanedStr.replace(/\./g, '').replace(',', '.'));
        } else { // dollar
          num = Number(cleanedStr.replace(/,/g, ''));
        }
      }
    }

    return num;
  }

  public static isValidCurrencyFormat(input: string, separador: string): boolean {
    let regex: any;
    switch (separador) {
      case 'dollar':
        regex = /^(\d{1,3}(,\d{3})*|\d{1,3}(,\d{3})*\.\d+|\d+\.\d+)$/;
        break;
      case 'euro':
        regex = /^(\d{1,3}(\.\d{3})*|\d{1,3}(\.\d{3})*,\d+|\d+,\d+)$/;
        break;
      case undefined:
        regex = /^\d+$/;
        break;
    }
    return regex.test(input);
  }

  public static validCurrencyFormat(valor: string): boolean {
    let isValid: boolean;
    if (this.esNulo(valor)) {
      return true;
    }
    const cleanedStr = valor.replace(/[^\d,.]/g, ''); // Quita los caracteres no numericos excepto la coma y punto
    const comaCount = (cleanedStr.match(/,/g) || []).length;
    const puntoCount = (cleanedStr.match(/\./g) || []).length;

    if (comaCount === 1 && puntoCount === 1) {
      // verificar las posiciones de la coma y el punto para determinar el tipo de moneda
      const charArray = [...cleanedStr];
      const comaIndex = charArray.indexOf(',');
      const puntoIndex = charArray.indexOf('.');
      if (puntoIndex < comaIndex) { // euro
        isValid = this.isValidCurrencyFormat(cleanedStr, 'euro');
      } else { // dollar mxn
        isValid = this.isValidCurrencyFormat(cleanedStr, 'dollar');
      }
    } else {
      if (comaCount === 0 && puntoCount === 0) {
        isValid = this.isValidCurrencyFormat(cleanedStr, undefined);
      } else {
        if (comaCount > puntoCount) { // 123456,56
          if (puntoCount !== 0) { // dollar
            isValid = this.isValidCurrencyFormat(cleanedStr, 'dollar');
          } else { // euro
            isValid = this.isValidCurrencyFormat(cleanedStr, 'euro');
          }
        } else { // 123456.56
          if (comaCount !== 0) { // euro
            isValid = this.isValidCurrencyFormat(cleanedStr, 'euro');
          } else { // dollar
            isValid = this.isValidCurrencyFormat(cleanedStr, 'dollar');
          }
        }
      }
    }

    return isValid;
  }

  public static isvalidQuantityFormat(valor: string): boolean {
    if (this.esNulo(valor)) { // revisar esto en Moneda
      return false;
    }
    const caracteresEspeciales = (valor.match(/[^0-9,.]/g) || []).length; // Cuenta los caracteres no numericos excepto la coma y punto
    const comaCount = (valor.match(/,/g) || []).length; // Cuenta las comas
    const puntoCount = (valor.match(/\./g) || []).length; // Cuenta los puntos
    if (caracteresEspeciales > 0) {
      return false;
    }
    if (comaCount === 1 && puntoCount === 1) {
      return false;
    }
    if (comaCount > 1 || puntoCount > 1) {
      return false;
    } else {
      const cantidad = Number(valor.replace(',', '.'));
      return !isNaN(cantidad);
    }
  }

  /**
   * Función para comparar el inicio de un campo con el valor de búsqueda
   * @param campo
   * @param value
   */
  public static filtroGridStartWith(campo: string, value: string) {
    return ClsUtil.quitarAcentos(ClsUtil.cadenaX(campo)).startsWith(value);
  }

  /**
   * Función para verificar si el valor está presente en cualquier campo
   * @param campo
   * @param words
   */
  public static filtroGridContainsAllWords(campo: string, words: string[]) {
    return words.every(word => ClsUtil.quitarAcentos(ClsUtil.cadenaX(campo)).indexOf(word) > -1);
  }

  /**
   * Definir función de filtrado según el valor de 'buscarInicio'
   * @param item
   * @param camposBuscar
   * @param buscarAlInicio
   * @param palabraABuscar
   */
  public static filtroGridMatchItem(item: any, camposBuscar: string[], buscarAlInicio: boolean, palabraABuscar: string) {
    if (buscarAlInicio) {
      return camposBuscar.some(campo => this.filtroGridStartWith(item[campo], palabraABuscar));
    } else {
      const filtros = palabraABuscar.split(' ');
      return camposBuscar.some(campo => this.filtroGridContainsAllWords(item[campo], filtros));
    }
  }

  /**
   * Copia los rows seleccionados o lo seleccionado de una celda
   * @param grid
   * @param pk
   * @param mObjGenerico
   */
  public static async copiarDatosGrids(grid: IgxGridComponent, pk: string, mObjGenerico: ClsObjGenerico) {
    try {
      const selectedKeys = new Set(grid.selectedRows);
      if (selectedKeys.size === 0) {
        mObjGenerico.opcionesCopiado.enabled = false;
        grid.clipboardOptions = mObjGenerico.opcionesCopiado;
        return '';
      }
      mObjGenerico.opcionesCopiado.enabled = true;
      grid.clipboardOptions = mObjGenerico.opcionesCopiado;
      const filteredData = grid.data.filter(row => selectedKeys.has(row[pk]));
      await navigator.clipboard.writeText(ClsUtil.getFormattedData(grid, filteredData));
      grid.deselectAllRows();
      return mObjGenerico.getTranslationsSubject('MENSAJES.TOAS.REGISTROS_COPIADOS').replace('{0}', selectedKeys.size.toString());
    } catch (e) {
      throw new Error(e.message);
    }
  }

  /**
   * Método que verifica si hay matrices pendientes de analizar
   * @param infPpto
   */
  public static hayMatricesPendientesDeAnalizar(infPpto: AppPresupuestosService): ClsConceptosPartida[] {
    try {
      const matrices = infPpto.pptoActivoCompletoJSON?.Presupuesto ?? []; // El operador ?? [] garantiza que si Matrices es undefined o null, se utilizará un arreglo vacío, evitando errores al intentar acceder a él.
      return Array.from(
        new Map(matrices
          .filter(item => item.PendienteAnalizar === true) // solo los pendientes
          .map(item => [item.Codigo, item])               // clave = Codigo
        ).values()
      );
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public static generarArrayDeMatricesPendientesDeAnalizar(objGenerico: ClsObjGenerico, hayMatricesPendientes: ClsConceptosPartida[]): ClsNotificaciones[] {
    try {
      let notif: ClsNotificaciones[] = [];
      const codigo: string = objGenerico.getTranslationsSubject('GRIDS.MATRIZ.COL_CODIGO');
      const unidad: string = objGenerico.getTranslationsSubject('GRIDS.MATRIZ.COL_UNIDAD');
      hayMatricesPendientes.forEach(mat => {
        notif.push({
          Type: EnumSocket.ModificarMatriz,
          IdMatriz: mat.IdCatalogo.toString(),
          Titulo: `${codigo}: ${mat.Codigo} | ${unidad}: ${mat.Unidad}`,
          Concepto: mat.Codigo,
          Descripcion: mat.Descripcion,
          Unidad: mat.Unidad,
          ObservacionPendiente: mat.ObservacionPendiente
        });
      });

      return notif;
    } catch (e) {
      throw new Error(e.message);
    }
  }
}

declare global {
  interface Array<T> {
    findLastIndex(
      predicate: (value: T, index: number, obj: T[]) => unknown,
      thisArg?: any
    ): number
  }
}
